webpackJsonp([1],{

/***/ "/Suc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var NavigationBar = ({
  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ef52442","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("/Suc")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3078df0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("eBnN")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Olympic Review - Issue 112",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/112"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/112"
  }],
  "basePath": "/112",
  // "basePath": "",
  "companyLogo": "1-logo.png",
  "publishURL": "http://olympic-review.s3-website-eu-west-1.amazonaws.com/112/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <img id=\"1-title\" class=\"halfScale\" style=\"top:14px;left:3px\" src=\"/112/static/_content/1-title.png\">\n      <img id=\"1-sub-1\" class=\"halfScale\" style=\"top:134px;left:501px\" src=\"/112/static/_content/1-sub-1.png\">\n      <img id=\"1-sub-2\" class=\"halfScale\" style=\"top:135px;left:16px\" src=\"/112/static/_content/1-sub-2.png\">\n      <img id=\"1-sub-3\" class=\"halfScale\" style=\"top:218px;left:266px\" src=\"/112/static/_content/1-sub-3.png\">\n      \n      <img id=\"1-logo\" class=\"halfScale\" style=\"top:812px;left:664px\" src=\"/112/static/_content/1-logo.png\">\n      <div class=\"addContentLink\" style=\"top:868px;left:664px;height:16px;width:120px;\">\n        <a href=\"http://www.olympic.org/en\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim.fromTo(idOf(\"1-title\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"1-sub-1\"), 0.6, {opacity:0, x:80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-sub-2\"), 0.6, {opacity:0, x:-80},{opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(idOf(\"1-sub-3\"), 0.6, {opacity:0, y:-80},{opacity:1, y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"1-logo\"), 0.6, {opacity:0, y:80},{opacity:1, y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JULY-AUGUST-SEPTEMBER 2019 NUMBER 112  TOKYO VISION WITH ONE YEAR TO GO, WE LOOK AT HOW THE OLYMPIC GAMES TOKYO 2020 IS SET TO DELIVER AN UNFORGETTABLE EXPERIENCE FOR ATHLETES AND FANS  WWW.OLYMPIC.ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 4-title\" style=\"top:133px;left:66px\" src=\"/112/static/_content/4-title.png\">\n        <img class=\"halfScale 4-title\" style=\"top:181px;left:67px\" src=\"/112/static/_content/4-sub.png\">\n        <img id=\"4-img\" class=\"halfScale\" style=\"top:239px;left:66px\" src=\"/112/static/_content/4-img-1.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:364px;left:67px\" src=\"/112/static/_content/4-img-2.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:487px;left:67px\" src=\"/112/static/_content/4-img-3.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:610px;left:67px\" src=\"/112/static/_content/4-img-4.jpg\">\n        <img class=\"halfScale 4-imgs\" style=\"top:733px;left:67px\" src=\"/112/static/_content/4-img-5.jpg\">\n\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:240px;left:67px;width:100px;height:100px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:365px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(46)\" style=\"top:488px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(62)\" style=\"top:611px;left:67px;width:101px;height:98px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:734px;left:67px;width:101px;height:98px\"></div>\n        \n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(7)\" style=\"top:237px;left:196px;width:101px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(8)\" style=\"top:272px;left:196px;width:99px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(12)\" style=\"top:308px;left:196px;width:69px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(24)\" style=\"top:344px;left:196px;width:169px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(26)\" style=\"top:392px;left:196px;width:262px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(46)\" style=\"top:463px;left:196px;width:219px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(56)\" style=\"top:523px;left:196px;width:174px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(62)\" style=\"top:570px;left:196px;width:204px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(68)\" style=\"top:618px;left:196px;width:249px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(74)\" style=\"top:678px;left:196px;width:107px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(78)\" style=\"top:726px;left:196px;width:158px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(81)\" style=\"top:761px;left:196px;width:112px;height:13px\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(82)\" style=\"top:809px;left:196px;width:112px;height:13px\"></div>\n\n        <div class=\"addContentLink\" style=\"top:701px;left:628px;width:56px;height:9px\">\n        <a href=\"http://www.olympic.org\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:710px;left:608px;width:88px;height:9px\">\n        <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n          .fromTo(idOf(\"4-img\"), 0.6, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power2.easeOut}, \"-=0.4\")\n          .staggerFromTo(cOf(\"4-imgs\"), 0.6, {opacity:0, y:-120},{opacity:1, y:0, ease: Power2.easeOut}, 0.2, \"-=0.2\", addContentLinks)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC REVIEW  CONTENTS OFFICIAL PUBLICATION OF THE OLYMPIC MOVEMENT JULY-AUGUST-SEPTEMBER 2019  7 FOREWORD By IOC President Thomas Bach.  8 SNAPSHOT Eye-catching sporting images from the past quarter.  The latest news and events from around the Olympic Movement.  24 BEYOND THE RINGS UN High Commissioner for Refugees Filippo Grandi discusses the participation of the Refugee Olympic Team at Tokyo 2020.  26 COVER STORY: ONE YEAR TO GO With less than one year to go until the Olympic Games Tokyo 2020, Olympic Review looks at how the hosts are blending tradition and modernity to deliver an unforgettable experience for athletes and fans.  46 TOKYO 2020 NEW SPORTS Skateboarding, sport climbing, surfing, karate, and baseball/softball are the five exciting new additions to the Olympic roster set to thrill audiences at Tokyo 2020.  56 THROUGH THE LENS We take a pictorial look at Japan’s long and cherished association with the Olympic Games.  62 TOKYO 2020 VISION Australia’s Chloe Esposito speaks about her struggles since winning an Olympic gold medal in modern pentathlon at Rio 2016.  68 INSIDE THE OLYMPIC CHANNEL The Olympic Channel’s latest original series, All Around, takes viewers on an intriguing real-time journey with three of the world’s leading gymnasts.  74 MY GAMES American sprinting legend Michael Johnson reflects on an incredible Olympic career.  78 OLYMPIC STUDIES News and book reviews from the IOC Olympic Studies Centre.  81 OBITUARIES Olympians and figures from the Olympic Movement who have passed away.  82 FAST FACTS Facts and figures about the Olympic mascots.  4 OLYMPIC REVIEW  EXECUTIVE BOARD President Thomas Bach Vice-Presidents Juan Antonio Samaranch, Uğur Erdener, Anita L. DeFrantz, Zaiqing Yu Members Sergey Bubka, Ser Miang Ng, Willi Kaltschmitt Luján, Robin E. Mitchell, Nicole Hoevertsz, Denis Oswald, Nenad Lalovic, Kirsty Coventry, Ivo Ferriani, HRH Prince Feisal Al Hussein OLYMPIC REVIEW Strategic Communications Director, a.i. Christian Klaue Editor-in-Chief Katharine Mann French Edition Blandine Potemsky Spanish Edition Dolores Blázquez Production Agency Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Gruffudd Owen, Conor Ketley Design John Paul Yetton, Vanesha Ramdoyal, Liz Rankin, Ana Burmester Image retouching Jason Dutch Translation Denis Echard, Héctor López Conceiro, Libero Language Lab Proofreading Libero Language Lab ISSN: 0377-192X Printed in the UK IMAGES Cover image: Getty Images/ Duane Walker. Inside: IOC; IOC/ Alexander Hassenstein; IOC/ Greg Martin; IOC/ Christophe Moratal; IOC/ John Huet; IOC/ Adam Mørk; Tokyo 2020; Getty Images; Shutterstock; Olympic Information Services; Lausanne 2020; Buenos Aires 2018; Olympic Channel; UNHCR; FIG; IAAF; COCH; Rania Rahardja. CONTACTS Please send your letters to: Olympic Review, IOC Strategic Communications Department, Château de Vidy, 1007 Lausanne, Switzerland website: www.olympic.org email: olympicreview@olympic.org tel +41 (0)21 621 6111 Olympic Review uses PEFCcertified paper stock sourced from sustainably managed forests. Olympic Review is published by the International Olympic Committee. The articles published in Olympic Review do not necessarily reflect the opinions of the International Olympic Committee. No articles may be reproduced without the permission of the IOC Strategic Communications Department.  All information correct at the time of going to press  12 NEWS"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Pictured The ofﬁcial countdown clock for the Olympic Games Tokyo 2020"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" style=\"top:772px;left:112px;height:16px;width:98px;\">\n          <a href=\"https://twitter.com/downewsroom?lang=en\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:772px;left:228px;height:16px;width:60px;\">\n          <a href=\"https://twitter.com/dowsports?lang=en\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:787px;left:98px;height:16px;width:208px;\">\n          <a href=\"https://www.linkedin.com/company/dow-chemical\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:808px;left:167px;height:16px;width:67px;\">\n          <a href=\"https://www.dow.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "Collaboration It’s where innovation begins  Our world is transforming, and our customers are facing constant change. They need a partner who will help them innovate to seize new opportunities and capture growth. That’s why we are committed to being the world’s most customer-centric materials science company. Through close collaboration, we work hard to understand our customers’ objectives and challenges, asking questions that lead to productive dialogue, stronger relationships and new answers. We are Dow, the world’s most customer-centric materials science company. @DowNewsroom and @DowSports Dow and Dow Olympic & Sports Solutions  dow.com ® and ™ are Trademarks of The Dow Chemical Company © 2019"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 7-title\" style=\"top:459px;left:150px\" src=\"/112/static/_content/7-title.png\">\n        <img class=\"halfScale 7-title\" style=\"top:548px;left:150px\" src=\"/112/static/_content/7-sub.png\">\n       \n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top:801px;left:581px;height:33px;width:123px\">\n          <img class=\"halfScale\" src=\"/112/static/_content/7-sig.png\">\n        </div>\n\n        <img id=\"7-ctr\" style=\"top:468px;left:41px;cursor:pointer;\" onclick=\"pg7show();\" src=\"/112/static/_content/clicktoread.png\">\n        \n        <div id=\"pg7read\" class=\"d-hidden\">\n          <img id=\"pg7close\" onclick=\"pg7readclose();\" src=\"/112/static/_content/x-button.png\">\n          <p>\n            A little under a year from now, all eyes will be on Japan as the world comes together in a celebration of sport and peace and harmony at the Olympic Games Tokyo 2020. I can truly say I have never seen an Olympic city as prepared as Tokyo with one year to go before the Olympic Games.\n          </p>\n          <p>\n            It will be the second time that the city of Tokyo hosts the Olympic Games, having first hosted them in 1964. Some of the venues used in 1964 will have another Olympic outing as they welcome athletes and spectators yet again.\n          </p>\n          <p>\n            These Games of the XXXII Olympiad will be innovative in so many ways. Just as Tokyo 1964 transformed the Games technologically \u2013 live TV images were beamed around the world for the first time, for example \u2013 Tokyo 2020 too will showcase the country\u2019s technological prowess. Fleets of low-carbon emission vehicles and automated driving solutions will be used to transport people, while robots assist with luggage at airports, give passengers directions and recommend tourist attractions in Japanese, English, Chinese and Korean. The city\u2019s sustainability credentials will also be on show, embodied by the medals that have been made using precious metals extracted from discarded laptops, mobile phones and other electronic devices donated by the Japanese public.\n          </p>\n          <p>\n            For the athletes Tokyo 2020 will offer new opportunities. With a record 48.8 per cent female participation, these Games will be practically gender equal. Thirty-three sports will feature on the programme, five of them new \u2013 baseball/softball is returning, while karate, sport climbing, surfing and skateboarding make their debuts. Of the 339 medal events, 18 are new. Tokyo 2020 will be more youthful, more urban and more female than any other Olympic Games before.\n          </p>\n          <p>\n            Already one year out, excitement is building for Tokyo\u2019s Games. Interest in tickets has exceeded all expectation with 3.2 million tickets being sold in the first round in Japan, while more than 200,000 people have applied to volunteer in one of the 80,000 positions so that they too can be part of the Olympic story.\n          </p>\n          <p>\n          All the elements that make up truly outstanding Olympic Games are in place. The athletes of all 206 National Olympic Committees as well as the IOC Refugee Olympic Team can look forward to an amazing experience. The pages that follow offer an early insight into what promises to be not only the world\u2019s greatest sporting event, but a celebration of the unity in diversity of all humankind.\n          </p>\n        </div>  \n      ",
    "script": "\n      function onPageEnter() {\n        pg7Anim = new TimelineMax();\n        pg7Anim.staggerFromTo(cOf(\"7-title\"), 0.8, {opacity:0, x:-80}, {opacity:1, x:0, ease: Power4.easeOut}, 0.4, 1)\n        .fromTo(idOf(\"7-sig\"), 0.6, {width:\"0px\"}, {width:\"123px\", ease: Power2.easeOut}, \"-=0.4\")\n        .fromTo(idOf(\"7-ctr\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n      }\n\n      function pg7show() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"readOverlay visible\"\n      }\n\n      function pg7readclose() {\n        var k =  document.getElementById(\"pg7read\")\n        k.className = \"d-hidden\"\n      }\n\n      function onPageLeave() {\n        pg7readclose();\n        pg7Anim.stop();\n      }\n      ",
    "searchText": "FOREWORD  FOREWORD BY THOMAS BACH PRESIDENT, INTERNATIONAL OLYMPIC COMMITTEE  A  Above right President Bach gave a fencing masterclass during the one-year-to-go celebrations  little under a year from now, all eyes will be on Japan as the world comes together in a celebration of sport and peace and harmony at the Olympic Games Tokyo 2020. I can truly say I have never seen an Olympic city as prepared as Tokyo with one year to go before the Olympic Games. It will be the second time that the city of Tokyo hosts the Olympic Games, having first hosted them in 1964. Some of the venues used in 1964 will have another Olympic outing as they welcome athletes and spectators yet again. These Games of the XXXII Olympiad will be innovative in so many ways. Just as Tokyo 1964 transformed the Games technologically – live TV images were beamed around the world for the first time, for example – Tokyo  2020 too will showcase the country’s technological prowess. Fleets of low-carbon emission vehicles and automated driving solutions will be used to transport people, while robots assist with luggage at airports, give passengers directions and recommend tourist attractions in Japanese, English, Chinese and Korean. The city’s sustainability credentials will also be on show, embodied by the medals that have been made using precious metals extracted from discarded laptops, mobile phones and other electronic devices donated by the Japanese public. For the athletes Tokyo 2020 will offer new opportunities. With a record 48.8 per cent female participation, these Games will be practically gender equal. Thirty-three sports will feature on the programme, five of them new –  baseball/softball is returning, while karate, sport climbing, surfing and skateboarding make their debuts. Of the 339 medal events, 18 are new. Tokyo 2020 will be more youthful, more urban and more female than any other Olympic Games before. Already one year out, excitement is building for Tokyo’s Games. Interest in tickets has exceeded all expectation with 3.2 million tickets being sold in the first round in Japan, while more than 200,000 people have applied to volunteer in one of the 80,000 positions so that they too can be part of the Olympic story. All the elements that make up truly outstanding Olympic Games are in place. The athletes of all 206 National Olympic Committees as well as the IOC Refugee Olympic Team can look forward to an amazing experience. The pages that follow offer an early insight into what promises to be not only the world’s greatest sporting event, but a celebration of the unity in diversity of all humankind. ■  OLYMPIC REVIEW 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  15/06/2019 ROAD CYCLING  The peloton rounds a tight corner during the seventh stage of the 2019 Critérium du Dauphiné. The iconic eightday event, which takes place in the southeast of France but finished in Switzerland this year, was eventually won by Danish rider Jakob Fuglsang, a silver medallist in the road race at the Olympic Games Rio 2016. Photo: Getty Images / AFP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SNAPSHOT  16/06/2019 RUGBY SEVENS  France’s Anne-Cécile Ciofani attempts to evade some Australian tackles as the two sides clash at the Parc des Sports Aguiléra in Biarritz, France. This was the first time the venue had been used in the World Rugby Women’s Sevens Series, and Olympic champions Australia eventually triumphed over the hosts by a scoreline of 24-10. Photo: Getty Images / AFP"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Imagine if the world could see what a mom sees. #LoveOverBias"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:523px;left:67px;width:504px;height:57px\">\n          <img class=\"halfScale\" id=\"12-title-1\" src=\"/112/static/_content/12-title.png\">\n        </div>\n\n        <a href=\"https://iocnewsroom.com/video/milan-cortina-awarded-the-2026-olympic-winter-games-and-paralympic-games-by-international-olympic-committee-ioc/\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:521px;left:63px;width:509px;height:49px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(idOf(\"12-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n    \n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MILANO-CORTINA AWARDED THE OLYMPIC WINTER GAMES 2026 On 24 June, the International Olympic Committee (IOC) announced that Milano-Cortina (Italy) will host the Olympic Winter Games 2026. The decision was taken during the 134th IOC Session in Lausanne. The other candidate was Stockholm-Åre (Sweden). Milano-Cortina was chosen to host the Olympic Winter Games in 2026 after receiving 47 out of a total of 82 votes, with Stockholm-Åre receiving 34 votes, with one abstention. IOC President Thomas Bach said: “Congratulations to MilanoCortina. We can look forward to outstanding and sustainable  12 OLYMPIC REVIEW  Olympic Winter Games in a traditional winter sports country. The passion and knowledge of Italian fans, together with experienced venue operators, will create the perfect atmosphere for the best athletes in the world.” Milano-Cortina 2026 prioritises sustainability and legacy, and its plan is fully in line with the Olympic Agenda 2020 reforms, which call for making maximum use of existing and temporary venues if there is no post-Games demand for new permanent facilities. As such, 13 out of a total 14 facilities (93 per cent) will be existing or temporary. The project has the  unified backing of the Italian sports movement, the private sector and national, regional and city governments – providing a solid foundation for its delivery. The IOC will support the staging of the Olympic Winter Games Milano-Cortina 2026 with a contribution of USD $925 million. The Candidature Process 2026 was built on increased partnership, flexibility and sharing of knowledge. This resulted in a significant cost reduction in the candidature budgets, projected to be more than 75 per cent lower than the average budgets for the 2018 and 2022 candidates.  Main picture The Milano-Cortina delegation celebrates after being awarded the 2026 Games"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:188px;left:51px;width:504px;height:57px\">\n          <img class=\"halfScale\" id=\"13-title-1\" src=\"/112/static/_content/13-title.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:321px;left:587px;width:144px;height:57px\">\n          <img class=\"halfScale\" id=\"13-title-2\" src=\"/112/static/_content/13-sub.png\">\n        </div>\n\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/-Ph5bEpFfqk')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:30px; height:30px;left:528px;top:196px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg13Anim = new TimelineMax();\n          pg13Anim.fromTo(idOf(\"13-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"13-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg13Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "EXPRESSION OF UNITY AS IOC INAUGURATES OLYMPIC HOUSE On 23 June, the IOC officially opened Olympic House – one of the most sustainable buildings in the world. The inauguration was the highlight of the emblematic and emotional celebrations to mark the 125th anniversary of the IOC, which was founded on 23 June 1894 by Pierre de Coubertin. The ceremony was attended by 700 guests, including President of the Swiss Confederation, Ueli Maurer; the IOC Members; the Presidents of the 206 NOCs and International Federations; and more than 30 Olympic medallists who, together with the IOC  Members, had won more than 125 medals at the Olympic Games. “When we set out on this project to construct a new home, we wanted it to be more than just another office building. Of course, we wanted to bring together everyone, the Olympic family and all IOC staff, under one roof. In this sense, Olympic House is an expression of our unity,” IOC President Thomas Bach said in his speech. Olympic House brings together the IOC staff – 500 employees previously spread across Lausanne in four locations – under one roof,  and is an investment by the IOC in sustainability. It has received three of the most rigorous sustainable building certifications: LEED Platinum, Swiss Sustainable Construction Standard Platinum, and the Swiss standard for energy-efficient buildings, Minergie-P. Olympic House is the first building to receive these three certifications, and the first in Switzerland to achieve LEED v4 Platinum. Below President Bach and President Maurer cut the ribbon to officially open Olympic House  IOC PRESIDENT ADDRESSES WORLD LEADERS On 19 June, IOC President Thomas Bach had the opportunity to address the world’s leaders at the G20 summit in Osaka (Japan). He was invited by Shinzō Abe, Prime Minister of Japan. Prime Minister Abe praised the IOC for its work and stressed the support for the mission of the Olympic Games. President Bach also had the opportunity to speak bilaterally to a number of heads of state and heads of government. In his speech, the IOC President talked about the role of the Olympic Games as the only event that unites the whole world in peaceful competition. “In a year from now, more than half of the world’s population will follow the Olympic Games Tokyo 2020,” he said. “At the Olympic Games, there is no discrimination; everyone respects the same rules; we are all equal. “In our fragile world we are living in today, such symbols of the unity of humanity in all our diversity give us hope for a better future.” Above President Bach spoke to world leaders at the G20 summit in Osaka in June  OLYMPIC REVIEW 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:553px;left:65px;width:504px;height:51px\">\n          <img class=\"halfScale\" id=\"14-title-1\" src=\"/112/static/_content/14-title.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:199px;left:616px;width:82px;height:40px\">\n          <img class=\"halfScale\" id=\"14-title-2\" src=\"/112/static/_content/14-sub.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(idOf(\"14-title-1\"), 0.6, {y:54}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"14-title-2\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "NEWS IN BRIEF  EVOLUTION OF THE REVOLUTION: IOC TRANSFORMS FUTURE GAMES ELECTIONS On 26 June, at the 134th IOC Session in Lausanne, the IOC took yet another step to transform future Olympic Games elections, approving the proposed changes accepted in May by the IOC Executive Board (EB). The key proposals, submitted by a Working Group previously set up by the EB, are: to establish a permanent, ongoing dialogue to explore and create interest among cities/regions/countries and National Olympic Committees (NOCs) for Olympic Games and Youth Olympic Games; to create two Future Host Commissions (Summer and Winter Games) to  14 OLYMPIC REVIEW  oversee interest in future Games and report to the EB; to preserve the magic of the Olympic Games to ensure a once-in-a-lifetime experience for the best athletes of the world; and to give the IOC Session more influence by having non-EB members form part of the Future Host Commissions. Based on input from these Host Commissions, the key principles to guide the work will be: an edition-based approach; a more contextualised approach; a more proactive manner to approach prospective hosts; a more open and flexible view of innovative proposals by prospective hosts;  “host” does not necessarily refer to a single city, but can also refer to multiple cities/regions/countries; and more responsible and flexible timing, adjusted to local opportunities, context and needs. The IOC Members will continue to be at the centre of the decisionmaking process, with the Session’s prerogative to elect Games hosts preserved. The corresponding changes to the Rules and Bye-laws of the Olympic Charter were also approved by the IOC Session. Above The IOC Session approved the key proposals put forward by the Working Group  IOC awards broadcast rights in Sub-Saharan Africa The IOC has awarded exclusive free-to-air broadcast rights in SubSaharan Africa to Infront Sports & Media AG (Infront) for the Olympic Games Tokyo 2020, the Olympic Winter Games Beijing 2022 and the Olympic Games Paris 2024, as well as the Youth Olympic Games Lausanne 2020 and Dakar 2022. Infront has acquired the rights for free-to-air television (and digital simulcast rights), and the agreement includes a commitment to ensure comprehensive live/ same-day coverage of each edition of the Olympic Games and daily highlights of the Olympic Winter Games on free-toair television. JTBC awarded Olympic broadcast rights in Korea On 4 June, the IOC announced that JTBC has been awarded the media rights in the Republic of Korea and the Democratic People's Republic of Korea for the Olympic Games during the period from 2026 to 2032. JTBC has acquired the rights across all media platforms, with a commitment to provide broad coverage across the organisation’s linear, digital and social media platforms."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:423px;left:50px;width:304px;height:71px\">\n          <img class=\"halfScale\" id=\"15-title-1\" src=\"/112/static/_content/15-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:335px;left:408px;width:324px;height:51px\">\n          <img class=\"halfScale\" id=\"15-title-2\" src=\"/112/static/_content/15-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:622px;left:408px;width:304px;height:43px\">\n          <img class=\"halfScale\" id=\"15-title-3\" src=\"/112/static/_content/15-title-3.png\">\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:423px;left:49px;height:57px;width:294px;\">\n          <a href=\"https://iocnewsroom.com/video/the-ioc-the-coca-cola-company-and-china-mengniu-dairy-company-ltd-announce-joint-worldwide-olympic-partnership-to-2032/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.fromTo(idOf(\"15-title-1\"), 0.6, {y:74}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"15-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"15-title-3\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC GOLDEN RINGS AWARD WINNERS UNVEILED IOC, COCA-COLA AND MENGNIU SIGN HISTORIC JOINT PARTNERSHIP On 24 June, the IOC, the Coca-Cola Company and China Mengniu Dairy Company Ltd announced they had signed the first-ever Joint TOP Partnership Agreement. It combines the non-alcoholic beverage and the dairy categories into a new joint category, and brings Mengniu into the family of Worldwide TOP Partners. The new joint agreement has a 12-year term running through to the Olympic Games 2032 and includes unprecedented investment in traditional and digital media to promote the Olympic values on a global scale. This agreement extends CocaCola’s association with the Olympic Movement to a historic 104-year-long relationship. CocaCola is the longest continuous Partner of the Olympic Games. Mengniu is the first Chinese fastmoving consumer goods company to become a TOP Partner. The  Joint TOP partnership supports Mengniu’s ambitious international growth plans, with the company aiming to become one of the top dairy producers in the world by 2025. IOC President Thomas Bach said: “This long-term agreement is another demonstration of the relevance and stability of the Olympic Games in these times of uncertainty. Having our longeststanding partner, Coca-Cola, an iconic American brand, together with a young Chinese company, Mengniu, joining hands under the roof of our Worldwide TOP Programme is a great example of the unifying power of the Olympic spirit. This partnership will give another dimension to the promotion of the Olympic values around the world.” Above President Bach with Mengniu CEO Jeffrey Lu and Coca-Cola CEO James Quincey  On 22 June, the IOC announced the winners of the prestigious award for the best broadcast coverage of the Olympic Winter Games Pyeongchang 2018 and Youth Olympic Games Buenos Aires 2018, during a ceremony held at Lausanne’s Salle Métropole. Winners were selected following a vote by an international jury headed by IOC Member Anant Singh. NBC won gold in four categories, namely the Best Olympic Feature, Best Olympic Digital Service, Best Olympic Programme and  Best Documentary Film, while Discovery and Eurosport also received a quartet of gold trophies (for Best On-Air Promotion, Best Production Design, Best Innovation and Best Social Media Content/Production). BBC Sport took home the Most Sustainable Operation and Best Feature at the Youth Olympic Games Buenos Aires 2018 awards; and NHK won the Best Athlete Profile category. Above The Golden Rings award winners were unveiled in front of 1,000 guests  IOC RECEIVES ZERO-EMISSION HYDROGEN FLEET FROM TOYOTA On 4 June, a fleet of Toyota Mirai zero-emission hydrogen fuel cell cars was delivered to the IOC in Lausanne as a key part of the organisation’s mobility plan. The eight Mirai passenger cars – otherwise known as fuel cell electric vehicles (FCEV) – were unveiled on the eve of World Environment Day at the new Olympic House during a handover ceremony with Worldwide Mobility Partner Toyota.  To allow refuelling of the vehicles, a temporary hydrogen fuelling station – one of the first in Switzerland – has been installed at the new IOC headquarters, before a public station is commissioned nearby. The station will produce and distribute hydrogen sourced from renewable energy to supply the IOC’s fleet of Toyota Mirai vehicles, as part of the organisation’s efforts to reduce its carbon emissions.  OLYMPIC REVIEW 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:440px;left:246px;width:484px;height:54px\">\n          <img class=\"halfScale\" id=\"16-title-1\" src=\"/112/static/_content/16-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:188px;left:66px;width:154px;height:51px\">\n          <img class=\"halfScale\" id=\"16-title-2\" src=\"/112/static/_content/16-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:670px;left:68px;width:614px;height:30px\">\n          <img class=\"halfScale\" id=\"16-title-3\" src=\"/112/static/_content/16-title-3.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg16Anim = new TimelineMax();\n          pg16Anim.fromTo(idOf(\"16-title-1\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"16-title-2\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"16-title-3\"), 0.6, {y:32}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg16Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC JOINS FORCES WITH OECD TO PROMOTE ETHICS The IOC and the Organisation for Economic Co-operation and Development (OECD) have agreed on a Memorandum of Understanding (MOU) aimed at strengthening their collaboration on promoting ethics, integrity and good governance, as well as peace and sustainable development in sport. The agreement was signed in Lausanne by IOC President Thomas Bach and OECD Secretary-General Angel Gurría. The collaboration with OECD will focus on four factors: combating corruption and promoting integrity in sport, including through the International Partnership against Corruption in Sport (IPACS); promoting responsible governance for sports organisations and sports events; fostering major sports events that aim to promote sustainable growth and development; and developing tools to evaluate the contribution of global events to local development and citizens’ well-being, based on rigorous and evidence-based analysis.  IOC SESSION ELECTS 10 NEW IOC MEMBERS AND TWO EB MEMBERS On 26 June, the 134th IOC Session elected HRH Prince Feisal Al Hussein and Nawal El Moutawakel as new members of the IOC Executive Board (EB). The Session also voted for 10 new members (pictured), following the proposal of the IOC EB from 22 May 2019. HRH Prince Feisal replaced Gunilla Lindberg on the IOC EB at the end of the Session, while Nawal El Moutawakel  will replace Willi Kaltschmitt Luján on 1 January 2020. The group of new IOC Members is composed of seven Individual Members and three Members whose election is linked to a function within an NOC or a Continental Association of NOCs. The new individual Members are Odette Assembe Engoulou (Cameroon), Spyros Capralos (Greece), Laura Chinchilla  (Costa Rica), Matlohang MoiloaRamoqopo (Lesotho), Filomena Fortes (Cape Verde), Tidjane Thiam (Côte d’Ivoire) and Erick Thohir (Indonesia). Narinder Dhruv Batra (India) and Kee Heung Lee (Republic of Korea) were elected linked to their function within an NOC, while Mustapha Berraf (Algeria) becomes an IOC Member with a role within a Continental Association of NOCs.  IOC PRESIDENT AWARDED INTERNATIONAL PEACE PRIZE On 3 June, IOC President Thomas Bach was awarded the prestigious Cem-Papandreou Peace Award in Athens. The international award is given to individuals and groups who have made “an outstanding contribution to peace”. In his opening remarks, the Greek Foreign Minister, George Katrougalos, described President  16 OLYMPIC REVIEW  Bach as a “champion of peace”. Presenting the award, former Greek Prime Minister George Papandreou highlighted the IOC President’s efforts in modernising the ancient concept of the Olympic Truce; the Refugee Olympic Team initiative; his work on promoting the idea of “peace education”; and his contribution  towards lasting peace through the joint Korean team at PyeongChang 2018. Accepting the award on behalf of the Olympic Movement and the IOC Members, President Bach said: “The Olympic Games show us that despite all our differences it is possible for humankind to live together in peace and harmony.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "AMAZING AHEAD Intel is proud to be a worldwide partner of the Olympic Games and to play a key role in accelerating the adoption of new technologies like drones, virtual reality, 5G, and artificial intelligence platforms. Together with partners, we are creating Olympic experiences that are more innovative and immersive than ever before. Learn more at intel.com/olympics  © Intel Corporation. Intel and the Intel logo are trademarks of Intel Corporation or its subsidiaries in the U.S. and/or other countries."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:190px;left:262px;width:484px;height:49px\">\n          <img class=\"halfScale\" id=\"18-title-1\" src=\"/112/static/_content/18-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:188px;left:66px;width:154px;height:51px\">\n          <img class=\"halfScale\" id=\"18-title-2\" src=\"/112/static/_content/18-title-2.png\">\n        </div>\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/EiejCgPJH3s')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:30px; height:30px;left:71px;top:696px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.fromTo(idOf(\"18-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"18-title-2\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "BEIJING 2022 TO USE INNOVATIVE COOLING SYSTEM  BREAKING, SKATEBOARDING, SPORT CLIMBING AND SURFING AT PARIS 2024  In a landmark decision guided by the IOC, natural CO2 refrigeration systems will be used in most of the Beijing 2022 ice venues, decreasing the overall carbon footprint of the Olympic Winter Games Beijing 2022. This will be the first time the technology is used in China and at the Olympic Games, and signifies a reduction of carbon emissions equal to the yearly footprint of almost 3,900 cars. A similar carbon reduction could also be achieved by planting more than 1.2 million trees. Meanwhile, on 18 July, Worldwide TOP Partner Alibaba Group was named as the ticketing systems and services provider for Beijing 2022 by the IOC and the Organising Committee. The Beijing 2022 ticketing programme will harness Alibaba’s technological and data expertise, ensuring a fully digitally enabled ticketing programme and modern user experience that allows fans to purchase and redistribute tickets securely.  Breaking, skateboarding, sport climbing and surfing have been provisionally included on the sports programme of the Olympic Games Paris 2024. The decision was taken by the 134th IOC Session. Paris 2024 is the second Organising Committee that has had the possibility to propose additional sports for its edition of the Games to the IOC. This flexibility is part of the reforms of Olympic Agenda 2020. “The four sports that Paris has proposed are all totally in line with Olympic Agenda 2020 because they contribute to making the programme more gender balanced and more urban, and offer the opportunity to connect with the younger generation,” said IOC President Thomas Bach. “The proposed sports are in line with these principles and enhance Paris 2024’s overall dynamic Games concept, which  Below Beijing 2022 will use natural CO2 cooling systems to reduce its carbon footprint  18 OLYMPIC REVIEW  focuses on inclusivity, inspiring a new audience and hosting socially responsible Games.” Breaking and sport climbing both appeared as medal events at the Youth Olympic Games Buenos Aires 2018, while skateboarding and surfing will make their debut on the Olympic programme in Tokyo next year. The proposal for the four sports builds on the evolution of the programme from  Tokyo 2020 and includes 248 athletes, which will fit within the 10,500-athlete quota, with equal numbers of women and men. In keeping with its commitment to host sustainable Games, Paris 2024 will use 95 per cent existing or temporary venues. Below Skateboarding fits well with Paris 2024’s dynamic Games concept"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:408px;left:263px;width:284px;height:49px\">\n          <img class=\"halfScale\" id=\"20-title-1\" src=\"/112/static/_content/20-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:683px;left:66px;width:424px;height:31px\">\n          <img class=\"halfScale\" id=\"20-title-2\" src=\"/112/static/_content/20-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:310px;left:67px;width:154px;height:39px\">\n          <img class=\"halfScale\" id=\"20-title-3\" src=\"/112/static/_content/20-title-3.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:199px;left:616px;width:94px;height:41px\">\n          <img class=\"halfScale\" id=\"20-title-4\" src=\"/112/static/_content/20-title-4.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.fromTo(idOf(\"20-title-1\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"20-title-2\"), 0.6, {y:35}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"20-title-3\"), 0.6, {y:40}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"20-title-4\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "NEWS IN BRIEF  IAAF UNVEILS NEW NAME AND LOGO On 9 June, the International Association of Athletics Federations (IAAF) Council approved the global governing body’s new name, “World Athletics”, and logo at the 217th IAAF Council Meeting in Monaco. The change will be introduced in October. The brand update represents a further step in line with the governance reform agenda of the previous four years, with the overarching aim to create a more modern, positive image of the sport, which in turn should make the sport more appealing to a wider audience. 'Our new brand will help attract and engage a new generation of young people to athletics,' said IAAF President Sebastian Coe. “We have now created a brand that can come to life in the digital world.”  ITTF ANNOUNCES OLYMPIC QUALIFIERS With less than one year to go until the Olympic Games Tokyo 2020, the International Table Tennis Federation (ITTF) announced that Portugal and Qatar will stage two World Olympic Qualification events branded #Rise2Tokyo. The World Team Qualification Event will take place in Gondomar, Portugal, from 22 to 26 January 2020, while the World Singles Qualification Event will be hosted in Doha,  Qatar, from 26 to 29 May 2020. Nine countries can qualify for the Tokyo 2020 team competition through the World Team Qualification Event, while the World Singles Qualification Event will allow between two and eight athletes to qualify for the men’s and women’s Tokyo 2020 singles competitions.  Above The Olympic qualification events will be hosted in Portugal and Qatar  FIFA SIGNS MOU WITH UN WOMEN On 5 June, the 69th Congress of the International Football Association Federation (FIFA) convened in Paris and re-elected Gianni Infantino as its President until 2023. Two days later, a memorandum of understanding (MoU) between FIFA and UN Women was signed by President  20 OLYMPIC REVIEW  Infantino and UN Under-SecretaryGeneral and Executive Director of UN Women, Phumzile MlamboNgcuka (pictured), at the FIFA Women’s Football Convention. Both organisations will work to make football more accessible to women and girls and to disseminate sports content to promote gender equality.  BWF launches AirBadminton On 13 May, the Badminton World Federation (BWF) unveiled a new version of the sport for outdoor play, AirBadminton. The format, which was presented for the first time in Guangzhou (China), has been created to allow a wide array of people to take part in the sport, regardless of age, gender, ability, or facilities available to them. In development for five years, AirBadminton will be played on new court dimensions to tailor it for outdoor environments, with the focus on promoting grassroots participation worldwide, rather than professional competition. FIH creates Women in Sports Committee On 23 May, the International Hockey Federation (FIH) created the Women in Sports Committee as a further milestone of its #EquallyAmazing strategy promoting gender equality. Chaired by FIH Executive Board member Marijke Fleuren, who is also a member of the IOC Women in Sport Commission, the committee’s primary objective will be to raise awareness about gender equality and inclusion while promoting diversity in sports practice and governance."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:188px;left:50px;width:584px;height:52px\">\n          <img class=\"halfScale\" id=\"21-title-1\" src=\"/112/static/_content/21-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:610px;left:49px;width:324px;height:43px\">\n          <img class=\"halfScale\" id=\"21-title-2\" src=\"/112/static/_content/21-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:610px;left:408px;width:294px;height:43px\">\n          <img class=\"halfScale\" id=\"21-title-3\" src=\"/112/static/_content/21-title-3.png\">\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(idOf(\"21-title-1\"), 0.6, {y:60}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"21-title-2\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"21-title-3\"), 0.6, {y:45}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg21Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "NOCS MARK OLYMPIC DAY AROUND THE WORLD WITH HELP FROM OLYMPIANS  On 23 June, National Olympic Committees (NOCs) around the world organised a host of sporting, cultural and educational activities in recognition of Olympic Day, all focused on delivering on the three fundamental pillars of  Olympic Day which are: “move”, “learn” and “discover”. In Lausanne, a group of some 30 children warmly welcomed Chilean Olympic champion Fernando González and Argentinian Olympic silver medallist Gabriela Sabatini  CZECH OLYMPIC COMMITTEE CELEBRATES 120TH ANNIVERSARY On 17 June, the Czech Olympic Committee (COV) held a special anniversary concert, featuring many of the world’s most prominent musicians, to celebrate its 120-year contribution to the Olympic Movement. Before the concert, four Czech sports personalities received awards, including threetime Olympic gold medallist in javelin, Jan Železný, and Oldřich Svojanovský, two-time Olympic medallist in rowing.  Also recognised were seventime Olympic gold medallist in gymnastics Věra Čáslavská (in memoriam), and František Pecháček (in memoriam), fourth at the 1920 Olympic Games with the gymnastics team. COV President and IOC Member Jiří Kejval said: “The four Czech personalities we awarded today were top athletes, but they also transcended sport to make a significant mark in other areas of society.”  on the central court of the StadeLausanne Tennis Club. All of them had the opportunity to play with the champions and benefit from their advice. Meanwhile, four-time Olympic medallist Luciana Aymar of Argentina was a special addition  to the regular Saturday morning practice sessions for the girls and boys of the Stade-Lausanne hockey club. The Czech Olympic Committee announced that over 75,000 participants, including over 60,000 children, took part in 81 races staged across all 14 regions of the country. The Japanese Olympic Committee also held an Olympic Day Run, as well as an Olympic concert to commemorate the occasion. More than 1,000 participants took part in the run in Shibetsu City, Hokkaido, host of the Olympic Day Run since 1991, with 10 Olympians joining in, including figure skater Takahiko Kozuka and fencer Kenta Chida. And in Chile, the National Olympic Training Centre invited primary school children to practise sports including karate and hockey. Above Chile’s National Olympic Training Centre invited children to take part in sports on Olympic Day  BELGIAN NOC AWARDS ‘OLYMPISM IN ACTION’ TROPHY On 24 May, the Belgian NOC awarded the 2018 IOC “Olympism in action” Trophy to the Royal Europa Kraainem Football Club and its President, Laurent Thieule. The initiative has reached more than 2,000 unaccompanied minor refugees, with the club hosting around 20 Afghan, Syrian, Iraqi or Eritrean refugees each week. The Trophy was presented by NOC President and IOC Member Pierre-Olivier Beckers-Vieujant (pictured).  OLYMPIC REVIEW 21"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:476px;left:245px;width:334px;height:80px\">\n          <img class=\"halfScale\" id=\"22-title-1\" src=\"/112/static/_content/22-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:192px;left:68px;width:134px;height:50px\">\n          <img class=\"halfScale\" id=\"22-title-2\" src=\"/112/static/_content/22-title-2.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:324px;left:604px;width:144px;height:51px\">\n          <img class=\"halfScale\" id=\"22-title-3\" src=\"/112/static/_content/22-title-3.png\">\n        </div>\n\n        <div class=\"addContentLink\" style=\"top:473px;left:242px;height:72px;width:331px;\">\n          <a href=\"https://stillmed.olympic.org/media/Document%20Library/OlympicOrg/News/2019/07/List-of-ARMs-Lausanne.pdf#_ga=2.82533974.1599139225.1567423598-504494508.1560240236\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg22Anim = new TimelineMax();\n          pg22Anim.fromTo(idOf(\"22-title-1\"), 0.6, {y:85}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"22-title-2\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"22-title-3\"), 0.6, {y:55}, {y:0, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg22Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "IOC ANNOUNCES LATEST YCM INITIATIVES The Young Change-Maker (YCM) programme is now in its fourth year and is more ambitious than ever. It helps young leaders deliver transformative projects in their local communities promoting social inclusion, gender equality and education through sport. Supported by seed-funding from the IOC of up to CHF 5,000, the new YCM cycle will see 50 new and ongoing initiatives undertaken across the globe over the next 12 months, up from 39 projects in the 2018-19 cycle. Young sports leaders from India, Portugal, Lebanon and Sweden are among just some of the successful grant applicants this year. Their projects include promoting badminton for disabled children, supporting domestic abuse survivors in sport classes and inspiring young female refugees through the release of a children’s book. The YCM Programme, a social entrepreneurship through sport initiative, is supported by the IOC’s TOP Partner Panasonic. Pictured Promoting wheelchair fencing in Singapore is one of the ongoing YCM projects  22 OLYMPIC REVIEW  LAUSANNE 2020 CAULDRON TO BE ECO-FRIENDLY  the athletes in the Youth Olympic Village, at training and competition venues, and during a series of educational activities and workshops. These activities will focus on a range of areas, including Olympic Solidarity, skills development, career management, injury prevention and integrity. Additionally, the general public and local young people will be able to meet and engage with the ARMs through sports presentations during the competitions, and at sports initiation sessions that will take place in competition venues and in the centre of Lausanne.  The organising committee for the Winter Youth Olympic Games (YOG) Lausanne 2020 has announced that its Olympic cauldron, construction of which began in June 2019, will be powered for the first time in the history of the Olympic Games by an eco-responsible fuel. In line with Lausanne 2020’s commitment to sustainability, the Olympic cauldron will be powered by wooden pellets. This system will make the flame fully autonomous for 24-hour cycles, which means that the burner will not need any external power supply to operate and will be filled with pellets only once a day. This project was chosen by a jury from among several submissions. The other proposals put forward will be showcased at the Olympic Museum from October 2019 until the end of the YOG. Production of the cauldron is scheduled to be completed in early autumn, in advance of the flame lighting ceremony in Greece and the Opening Ceremony on 9 January.  Pictured Curler John Morris will be working alongside YOG athletes in Lausanne  Pictured Engineers work on the construction of the Olympic cauldron for Lausanne 2020  SPORTING LEGENDS TO SUPPORT ATHLETES AT LAUSANNE 2020 On 25 July, the IOC announced the first 13 Athlete Role Models (ARMs) who will support the young athletes going to the 3rd Winter YOG from 9 to 22 January 2020 in Lausanne. Selected by the International Federations whose sports will be featured at Lausanne 2020, the list includes many legendary names from the world of sport, including Olympic and world champions such as German luger Tatjana Hüfner and Canadian curler John Morris. In Lausanne, they will play a key role in supporting, mentoring and offering advice to the 1,880 young athletes who will be participating in the Games next year. The ARMs will engage and share their experiences with"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "As the Worldwide IT Partner of the Olympic Games since 2001, Atos delivers critical Games applications, IT security, cloud services and many more solutions to help create the Olympic Games of the future. Want to see what the Olympic story could mean to you? Join us at atos.net/olympicgames  Maximum performance to build your journey to success Trusted partner for your Digital Journey"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <div class=\"abs noOverflow\" style=\"top:226px;left:66px;width:354px;height:100px\">\n          <img class=\"halfScale\" id=\"24-title-1\" style=\"top:20px\" src=\"/112/static/_content/24-title-1.png\">\n        </div>\n        <div class=\"abs noOverflow\" style=\"top:193px;left:66px;width:223px;height:37px\">\n          <img class=\"halfScale\" id=\"24-title-2\" src=\"/112/static/_content/24-title-2.png\">\n        </div>\n        <img class=\"halfScale\" id=\"24-sub-1\" style=\"top:340px;left:67px;\" src=\"/112/static/_content/24-sub-1.png\">\n\n        <div class=\"addContentLink\" style=\"top:243px;left:62px;height:82px;width:352px;\">\n          <a href=\"https://www.olympic.org/news/ioc-announces-list-of-refugee-athlete-scholarship-holders-aiming-to-be-part-of-ioc-refugee-olympic-team-tokyo-2020\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(idOf(\"24-title-1\"), 0.6, {y:-125}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"24-title-2\"), 0.6, {y:50}, {y:0, ease: Power2.easeOut}, \"-=0.3\")\n          .fromTo(idOf(\"24-sub-1\"), 0.6, {y:35, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "COLUMN  BEYOND THE RINGS  SUPPORTING REFUGEES FILIPPO GRANDI, UNITED NATIONS (UN) HIGH COMMISSIONER FOR REFUGEES, DISCUSSES THE IMPACT OF THE IOC REFUGEE OLYMPIC TEAM TOKYO 2020  W  ith more than 70 million people now forcibly displaced around the world owing to conflict, violence and persecution, sport is emerging as a powerful tool that can help them rebuild their lives and become part of new communities. The partnership between the UN Refugee Agency (UNHCR) and the International Olympic Committee (IOC) – which has now spanned some 25 years – is helping inspire new forms of collaboration that harness the potential of sport to bring people together, at a time when the public debate around refugees and migrants is increasingly divisive in many parts of the world. Together, UNHCR and the IOC are spearheading a drive to use sports programmes in safe and protective environments to help refugee children and youth build confidence, develop their potential and restore the prospect of a better future. Three recent developments are particularly significant. First, the establishment of the Olympic Refuge Foundation by the IOC in 2017, with the aim of helping one million forcibly displaced young people to access safe sport by 2024, has provided a vital new vehicle for this work. Second, guidance for sports and humanitarian organisations on achieving social outcomes through sport is now available through the “Sport for  24 OLYMPIC REVIEW  Protection Toolkit: Programming with Young People in Forced Displacement Settings” developed jointly by the IOC and UNHCR. Third, the role of sport as part of the global response to refugee crises was recognised in the Global Compact on Refugees – a new framework for action agreed by the UN General Assembly in December 2018. One year ahead of Tokyo 2020, the announcement that there will be a new IOC Refugee Olympic Team has added new momentum to these efforts. Established by the IOC in 2016 against a backdrop of growing refugee crises around the world, this bold and visionary initiative helped mobilise public understanding and solidarity with refugees on a scale never before witnessed. At Rio 2016, the Refugee Olympic Team’s participation under the Olympic flag brought refugee issues into the homes of the world’s sport-watching public, capturing their imagination and showing the human side of today’s displacement crises, through the medium of sport. The participation of the 10 refugee athletes also inspired refugee children and youth – giving them hope that they too might one day excel on the world’s largest sporting stage, side-by-side with their peers. The IOC Refugee Athlete Support Programme, established following the Games, now enables more than 40 refugee athletes from around the  world to train and reach elite standards. I am delighted that the tradition of the Refugee Olympic Team is to continue in Tokyo, and am grateful to the IOC for once again providing exceptional young refugees the opportunity to compete with the world’s best. Although the global environment for refugees and migrants has become even more challenging since 2016, the symbolism of a Refugee Olympic Team at Tokyo 2020 shows clearly that the Olympic Movement and the world of sport stand alongside refugees, and organisations like UNHCR who work for them. This is invaluable in helping us overcome divisive narratives and tell the stories of the overwhelmingly positive contributions made by the more than 25.9 million refugees who have been forced to flee their homes and countries, to preserve their own and their family’s lives. With less than one year to go, I urge you to remember that there will be a team competing in Tokyo without a country behind it, or its own supporters – but that represents all those uprooted from their homes worldwide, and calls attention to their plight. Please spare the Refugee Olympic Team, and all those whom they represent, a little of your support at Tokyo and beyond – and in this way, help to further the vision of mutual understanding and solidarity that lies at the heart of the Olympic spirit. ■  Filippo Grandi is the 11th UN High Commissioner for Refugees. He was elected by the UN General Assembly on 1 January 2016 to serve a five-year term, until 31 December 2020.  Top right Filippo Grandi with the ﬁrst Refugee Olympic Team at Rio 2016"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "YOU PUSH YOURSELF TO NEW HEIGHTS. WE PUSH FOR NEW WAYS TO PAY.  Kanoa Igarashi Team Visa  Visa. The exclusive payment technology partner of Tokyo 2020 and Worldwide Sponsor of the Olympic Games for over 30 years."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"26-title\" style=\"top:319px;left:37px;\" src=\"/112/static/_content/26-title-1.png\">  \n        <img class=\"halfScale\" id=\"26-sub\" style=\"top:599px;left:146px;\" src=\"/112/static/_content/26-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(idOf(\"26-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(idOf(\"26-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "WOMEN IN TO SPORT ONE YEAR GO  READY STEADY TOKYO WITH LESS THAN ONE YEAR TO GO UNTIL THE OLYMPIC GAMES TOKYO 2020, JAPANESE SPORTS JOURNALIST SHINTARO KANO LOOKS AT HOW THE HOSTS ARE BLENDING TRADITION AND MODERNITY TO DELIVER AN UNFORGETTABLE EXPERIENCE FOR ATHLETES AND FANS  26 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  OLYMPIC REVIEW 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      <svg onclick=\"Publish.openGallery(['28-gal-1.jpg', '28-gal-2.jpg', '28-gal-3.jpg', '28-gal-4.jpg', '28-gal-5.jpg', '28-gal-6.jpg', '28-gal-7.jpg', '28-gal-8.jpg', '28-gal-9.jpg', '28-gal-10.jpg'])\" class=\"abs pointer pulse animatedpulse \"style=\"left:85px;width:50px; top:535px; height:50px;\" viewBox=\"0 0 160.62 157.733\" enable-background=\"new 0 0 160.62 157.733\">\n          <g>\n            <path fill=\"#000\" d=\"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n              c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z\"/>\n            <path fill=\"#000\" d=\"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n              c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n              h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n              c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n              M123.685,63.134h-20.209v-5.966h20.209V63.134z\"/>\n          </g>\n          <g>\n            <path fill=\"#000\" d=\"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n              c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n              c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n              c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n              c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n              c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n              c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n              C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n              c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n              c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n              c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n              L154.856,78.867z\"/>\n          </g>\n        </svg>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  M  annosuke and Bungo Suzuki, father-and-son founders, designed the Olympic cauldron at the old National Stadium in Tokyo where the flame for the Olympic Games 1964 burned brightly. And every year without fail since those Games, Bungo made it a ritual to neatly polish and shine the cauldron with sesame oil around 10 October – the date of the Tokyo 1964 Opening Ceremony. When Bungo passed away in 2008, an ideal successor who read about him emerged to keep the tradition alive: Koji Murofushi, Athens 2004 gold medallist and now the Sports Director of the Tokyo Organising Committee of the Olympic and Paralympic Games  28 OLYMPIC REVIEW  Above Local youngsters try out hockey at a one-year-togo event Left Tokyo’s Olympic cauldron has been well preserved since 1964 Right Anticipation is building in the host city"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"29-quote\" style=\"top:732px;left:50px;\" src=\"/112/static/_content/29-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg29Anim = new TimelineMax();\n          pg29Anim.fromTo(idOf(\"29-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg29Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  (Tokyo 2020). Known for a craftsmanlike work ethic himself as a hammer thrower, Murofushi was so deeply moved by Bungo’s story that he decided to carry on the torch to preserve the spirit of 1964, which he feels epitomises the Olympic Movement. And it is with this type of spirit, one of meticulous care and attention to minute detail, that Tokyo’s second Olympic Games is being organised. “I think the approach we have taken in everything we do has been one of precision and careful planning – a very Japanese approach, so to speak,” Murofushi says. “We have never done anything on the fly and as an Organising Committee, take pride in the solid work we have put in under the leadership of Tokyo 2020 President [Yoshirō] Mori and CEO [Toshiro] Muto. “After it’s all said and done, we want people to be glad we were awarded the rights to these Games. That is the type of Olympic Games we want to organise. It is a once-in-a-lifetime opportunity and we want everyone who visits next year to take home a bag of memories – an absolute experience. “It will definitely be a new Olympic experience for all and there will be a lot of modern technology used in our organisation. But I think one of the things Japan has always done well is blend modernity and tradition, and I am counting on these Games to do just that.” The date of 24 July marked one year to go to Tokyo 2020 as the countdown got under way, nearly six years after the Japanese capital was elected host city of the Games of the XXXII Olympiad. As part of the one-year-to-go festivities, Tokyo 2020 staged the “Let’s 55” (Go Go) event, which allowed the public to  ‘IT IS A ONCE-IN-A-LIFETIME OPPORTUNITY AND WE WANT EVERYONE WHO VISITS NEXT YEAR TO TAKE HOME A BAG OF MEMORIES – AN ABSOLUTE EXPERIENCE’ KOJI MUROFUSHI, TOKYO 2020 SPORTS DIRECTOR  OLYMPIC REVIEW 29"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"30-quote\" style=\"top:331px;left:566px;\" src=\"/112/static/_content/30-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg30Anim = new TimelineMax();\n          pg30Anim.fromTo(idOf(\"30-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg30Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  ‘THIS IS NOT ONLY ABOUT SPORT; IT’S ABOUT EDUCATING PEOPLE IN VARIOUS WAYS. THIS IS THE POWER OF THE OLYMPIC GAMES AND WHAT IT CAN DO’ KOJI MUROFUSHI, TOKYO 2020 SPORTS DIRECTOR  experience a selection of the 55 disciplines set to feature at the Games, and was met with great enthusiasm as more than 15,000 people flocked to the Tokyo International Forum to participate. Japan’s Olympic passion has never been in question, but even by Japanese standards the level of anticipation in the country for next summer’s Games has been extraordinary, thanks to various engagement programmes such as the Tokyo 2020 Medal Project, which recycled mobile phones and other small electronic appliances donated by the Japanese public to produce the Olympic medals. In the selection of the official mascots for the Olympic and Paralympic Games – Miraitowa and Someity – almost 17,000 elementary schools nationwide and Japanese schools overseas took part in the voting process.  30 OLYMPIC REVIEW  And tickets have flown off the shelf, with more than three million sold during the initial phase of lottery sales after around 7.5 million residents in Japan signed up for Tokyo 2020 ID registration. “The people of Japan have great excitement for the Games,” said John Coates, Chairman of the IOC Coordination Commission for Tokyo 2020. “We already see an incredible level of enthusiasm, with unprecedented levels of interest in buying tickets, an excellent contribution from the public in recycling phones to create the Olympic medals, and the overwhelming number of applications to become a volunteer.” Excitement is growing internationally too, with an estimated 110 heads of state planning to attend. Tokyo has lived up to its self-billing as a safe pair of hands since being  Above Karate is one of four sports that will make its Olympic debut at Tokyo 2020 Above right A popular scheme encouraged the public to recycle metal to use in the Olympic medals  awarded the hosting rights. With less than a year of preparation remaining, Tokyo could not be more ready. As of June 2019, five of the eight new permanent venues had already been completed, with the Olympic Stadium – built on the same grounds as the 1964 Olympic Stadium – 90 per cent finished and set for delivery in November 2019. Ariake Arena is slated for completion in December, and the last venue that will be delivered – Tokyo Aquatics Centre – will open in February next year. In all, 43 venues will be used for Tokyo 2020 with 25 of them on existing sites and 10 temporary, in two main operational zones: the Heritage Zone, comprising of iconic venues from the 1964 Games, and the Tokyo Bay Zone, which symbolises the city’s future and innovative urban development. The residential buildings of the Olympic Village – located in the Harumi waterfront district on a 44-hectare plot and equipped with 18,000 beds – will be completed in December. They will be converted and sold as apartments following the Games. A total of 56 test events will be conducted in three waves by May 2020, covering every Olympic discipline."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 31-title\" style=\"top:188px;left:53px;\" src=\"/112/static/_content/31-title.png\">\n        <img class=\"halfScale 31-title\" style=\"top:265px;left:130px;\" src=\"/112/static/_content/31-sub.png\">\n\n        <h1 id=\"31-no1\" class=\"abs 31-no hn-bd\" style=\"left:79px;top:390px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 43 }' ></h1>\n        <h1 id=\"31-no2\" class=\"abs 31-no hn-bd\" style=\"left:74px;top:643px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 339 }' ></h1>\n        <h1 id=\"31-no3\" class=\"abs 31-no hn-bd\" style=\"left:176px;top:642px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 18 }' ></h1> \n        <h1 id=\"31-no4\" class=\"abs 31-no hn-bd\" style=\"left:639px;top:742px; font-size: 1.4em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 48.8, \"decimals\": 1, \"append\": \"%\" }' ></h1> \n      ",
    "script": "\n        function onPageEnter() {\n          pg31Anim = new TimelineMax();\n          pg31Anim.staggerFromTo(cOf(\"31-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n                  .fromTo(cOf(\"31-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[0]);}}, \"-=0.3\")\n                  .fromTo(cOf(\"31-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[1]);}}, \"-=0.3\")\n                  .fromTo(cOf(\"31-no\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[2]);}}, \"-=0.3\")\n                  .fromTo(cOf(\"31-no\")[3], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"31-no\")[3]);addContentLinks();}}, \"-=0.3\")\n          }\n          function onPageLeave() {\n            removeContentLinks();\n            pg31Anim.stop();\n            resetNumbers('31-no');\n          }\n      ",
    "searchText": "ONE YEAR TO GO  TEST EVENTS 56 held in three waves  TOKYO 2020 IN NUMBERS THE LATEST FACTS AND FIGURES WITH ONE YEAR TO GO  2 ND WAVE OCT 2019-FEB 2020 Focuses mainly on indoor sports  VENUES  43 VENUES IN TOTAL  25 existing 10 temporary 8 new and permanent  1ST WAVE JUN-SEPT 2019 Focuses on outdoor sports  OUT OF THE EIGHT NEW VENUES, FIVE ARE COMPLETED  ATHLETES (compared to 11,238 at Rio 2016)  SPORTS  339  18  EVENTS IN TOTAL  NEW EVENTS  FIRST OLYMPIC MEDALS TO BE AWARDED IN:  karate, sport climbing, surﬁng and skateboarding  INCLUDING 474 ATHLETES FROM NEW SPORTS  3RD WAVE MAR-MAY 2020 Focuses on remaining sports  people applied to be a volunteer for Tokyo 2020  GENDER EQUALITY ALMOST 50 PER CENT OF ATHLETES WILL BE FEMALE, MAKING TOKYO 2020 THE MOST GENDERBALANCED GAMES TO DATE  48.8% FEMALE  OLYMPIC REVIEW 31"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  Above Rowing will be held at the Sea Forest Waterway in Tokyo Bay Left Action from the test event for modern pentathlon  32 OLYMPIC REVIEW  They will be organised by International and National Federations – some of them world championships, World Cups and competitions with Olympic qualification available – in partnership with Tokyo 2020, who have branded the events “Ready Steady Tokyo”. By the end of September, 24 test events will already have been held in sports such as rowing, sailing, triathlon and judo. Further anticipation is set to be created by the Olympic Torch Relay, which starts in March 2020. The concept for the relay is “Hope Lights Our Way”, uniting the Japanese people around messages of supporting, accepting and encouraging one another. The relay will take in areas that are continuing to recover from natural disasters, such as the Tohoku region, which was struck by the 2011 earthquake and tsunami. With recovery and reconstruction a major theme of Tokyo 2020, these disasteraffected areas will also host sporting events during the Games, with"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"34-quote\" style=\"top:607px;left:367px;\" src=\"/112/static/_content/34-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n          pg34Anim.fromTo(idOf(\"34-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg34Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  Above Visitors to Tokyo will be able to enjoy the city’s famous landmarks during the Games Right The Olympic torch design took inspiration from the Japanese cherry blossom  34 OLYMPIC REVIEW  ‘THE PEOPLE OF JAPAN HAVE GREAT EXCITEMENT FOR THE GAMES. WE ALREADY SEE AN INCREDIBLE LEVEL OF ENTHUSIASM, WITH UNPRECEDENTED LEVELS OF INTEREST’ JOHN COATES, CHAIR OF IOC COORDINATION COMMISSION FOR TOKYO 2020 baseball and softball matches taking place in Fukushima’s Azuma Stadium, and football played at the nearby Miyagi Stadium. If Tokyo’s previous Olympic Games in 1964 is widely credited for helping spur the national economy and turning Japan  into a major global player, the country sees Tokyo 2020 as an opportunity to show the world how far it has come since. Japan is taking the responsibility of being gracious hosts very seriously, going the extra distance to make sure visitors next summer feel welcome in the spirit of omotenashi, or hospitality at its finest. Lured by landmark attractions like Tokyo Skytree and Sensoji Temple to trend hubs Shibuya and Harajuku, a record 31 million foreign tourists came to Japan in 2018. The figure rose for the seventh straight year and is steadily climbing towards the target of 40 million set by the government in 2020. While it has always had an excellent culinary reputation, Tokyo has become a once-in-a-lifetime destination spot for foodies around the globe with a wide array of options, from Michelin-starred restaurants to grunge street food to impossibly delicious bowls of ramen. Permeating life in Tokyo at all levels is modern technology, and Tokyo 2020 is declaring the Games to be the most innovative ever. Around 200 shortdistance battery vehicles will transport athletes, staff and visitors with accessibility needs around venues, and the Tokyo 2020 Robot Project, featuring four different robot types, will assist spectators, athletes and officials at the venues while virtually engaging with fans watching remotely. Expectations on the field of play will be sky-high for Japanese athletes. The Japanese Olympic Committee has set a goal of 30 gold medals for its delegation – almost double its all-time best of 16 at Tokyo 1964 and Athens 2004. But with a new generation of athletes like Daiya Seto (swimming), Naomi Osaka (tennis), Abdul Hakim Sani Brown (athletics), Kento Momota (badminton) and Misugu Okamoto (skateboarding) leading the way, an unprecedented medal haul seems within reach for the hosts. Tokyo 2020 will feature a record 33 sports and 339 events over the 17-day period from 24 July to 9 August, including five additional sports proposed by Tokyo 2020 in line with Olympic Agenda 2020. Baseball/softball returns"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/bK3urL69pdk')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:78px;top:192px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  to the Olympic programme; karate, skateboarding, sport climbing and surfing are brand new additions. Many eyes will be on the new sports as they target a younger audience unseen at previous Games. The Aomi Urban Sports Venue where 3x3 basketball and sport climbing will be held, and the Olympic BMX Course geared for BMX freestyle, BMX racing and skateboarding, should create an entirely different Olympic experience that will only add to the scope and depth of the Games. Each sport is part of an “Urban Festival” that will feature exhibition performances and concerts, and allow fans to get closer to the action than ever before at the “Playground”, where they can watch Olympians  Above The Tokyo 2020 Robot Project has been developed in partnership with Worldwide TOP Partners Toyota and Panasonic Right Swimmer Daiya Seto will be one of Japan’s leading medal hopes  OLYMPIC REVIEW 35"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  surfing culture that heightens things like environmental awareness, which in turn leads to reduced plastic waste in the ocean, and cleaner water. “Each sport will have its own flavour but I think the one unique thing you can say about Tokyo 2020 is the presentation of the sports; how you watch it, how you take part in it. The athletes will be allowed to focus on competing but the fans will also feel fully involved. That is an area we have invested in. I think people can expect a lot from our Games, to go to the venue and be part of an unprecedented experience.” ■ IN THE NEXT ISSUE: With the 3rd edition of the Winter Youth Olympic Games (YOG) taking place from 9 to 22 January, we preview Lausanne 2020 and highlight what young athletes and fans can expect from the host city. From an innovative new venue concept to technology that will reduce the carbon footprint of the YOG, it is set to shape Olympic events of the future. warm up, and even try out the facilities themselves. Surfing at the Tsurigasaki Beach venue in Tokyo’s neighbouring Chiba Prefecture is another potential game-changer in terms of what future Games might have to offer, with a similarly inclusive surfing festival planned around the four days of competition. And that is just scratching the surface of what adding sports to the Olympic programme can do, says Murofushi, who feels the impact will extend far beyond the realm of sport. “This is not only about sport; it’s about educating people in various ways,” he said. “Education is about changing a mind-set and we need to remember that education is not only for children. This is the power of the Olympic Games and what it can do. “Take the five new sports for example. When you add those five, you’re not just introducing new sports but bringing a whole new culture to the masses, which, in turn, raises the value of the IOC and sport in general. So when you add surfing, you are also adding the  36 OLYMPIC REVIEW  Above Creating an environmentally responsible event has been central to planning Right Tokyo 2020 will inspire the next generation of athletes in the host country"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"38-title\" style=\"top:321px;left:67px;\" src=\"/112/static/_content/38-title.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(idOf(\"38-title\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  Right Local youngsters have embraced the “Let’s 55” programme  SPORT FOR ALL AS TOKYO CELEBRATES ONE YEAR TO GO On 24 July, residents of Tokyo were invited to try out some of the Olympic sports for themselves as part of celebrations to mark one year to go to the Opening Ceremony of the Olympic Games Tokyo 2020. Visitors to the Tokyo International Forum, which will be the venue for weightlifting during the Games, were encouraged to try a variety of disciplines that will feature at the Games. Several Japanese athletes also showcased their skills as part of the Tokyo 2020 Organising Committee’s “Let’s 55” programme, which is inspiring members of the public to participate in sport. IOC President Thomas Bach was among those to get involved, practising fencing with local children before formally inviting the athletes of the world to Tokyo 2020 during the evening’s official one-year-to-go ceremony. “One year from now, Japan will make history,” he said. “It will be a wonderful and unique moment for our  38 OLYMPIC REVIEW  gracious Japanese hosts to show the world the best of Japan: your rich history and traditions, your cutting-edge innovation, your culture of hospitality and, of course, your love for sport.” Japanese Prime Minister Shinzō Abe, IOC Coordination Commission chair John Coates, Tokyo Governor Yuriko Koike, and the President of the Tokyo 2020 Organising Committee, Yoshirō Mori, were among those attending the ceremony. The day’s celebrations concluded with the unveiling of a special countdown clock created by OMEGA, the Official Timekeeper of the Olympic Games, in front of Tokyo station, which is used by more than one million people every day. As night fell on the Japanese capital, the Tokyo Metropolitan Government building in Shinjuku and the city’s landmark Tokyo Tower and Tokyo Skytree were also specially illuminated to mark the milestone. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title\" style=\"top:178px;left:67px;\" src=\"/112/static/_content/40-title.png\">\n        <img class=\"halfScale 40-title\" style=\"top:307px;left:67px;\" src=\"/112/static/_content/40-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.staggerFromTo(cOf(\"40-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  ‘A ROLE MODEL FOR FUTURE GAMES’ AS ANTICIPATION BUILDS FOR THE OLYMPIC GAMES TOKYO 2020, TOSHIRO MUTO, CEO OF THE ORGANISING COMMITTEE, TELLS OLYMPIC REVIEW HOW THE GAMES WILL DELIVER POSITIVE CHANGE FOR JAPAN AND THE REST OF THE WORLD  TOSHIRO MUTO Tokyo 2020 CEO  Q: With one year to go, how much interest is the Japanese public showing in the Games? A: A total of 204,680 people in Japan and overseas have applied for the 80,000 positions on offer through the Tokyo 2020 Volunteer Programme. The high level of interest in Japan and overseas indicates that people everywhere are motivated to support and be involved in the Games. At the close of the ﬁrst phase of ticket sales, Tokyo 2020 announced that more than ﬁve million people in Japan had applied, with more than three million tickets purchased.  The number of applications exceeded our expectations, an indication of the growing passion for the Olympic Games in the country. Q: What is planned in the test event programme for the Games? A: More than 50 test events will be held between September 2018 and May 2020. Some will be part of existing scheduled international sporting events taking place in Japan during the build-up to the Games, while others will be dedicated Olympic and Paralympic test events organised by Tokyo 2020. Some test events will allow the Japanese public to catch a glimpse of the world’s best athletes in those sports, including potential Olympic competitors – an exciting chance for those thinking of coming to the Games to discover new sports and heroes. Q: What can fans and athletes expect from the Games? A: All athletes and fans will be warmly welcomed by the residents of Tokyo and all Japanese citizens in the spirit of omotenashi, which is an honoured Japanese tradition of providing guests with meticulous hospitality. Our mission is to provide a stage on which all athletes can perform to their best. We are conﬁdent that  40 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  OLYMPIC REVIEW 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"42-quote\" style=\"top:309px;left:380px;\" src=\"/112/static/_content/42-quote.png\">  \n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(idOf(\"42-quote\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  everyone who watches or participates in the Games will remember them as the best in history. Q: What innovations will we see at Tokyo 2020? A: We expect the Tokyo 2020 Games to be the most innovative ever. Several engagement initiatives are being held, including the Tokyo 2020 Medal Project, whereby winners’ medals are being made using precious metal from discarded consumer electronic devices, while the Tokyo 2020 mascots were selected by elementary school students. We have been listening to the opinions of experts, sponsors and other related parties, and have discussed with them the deployment of robots as a means of demonstrating the Japanese omotenashi hospitality and showcasing high technology. For example, the human support robot and delivery support robot will allow all spectators to enjoy watching the Games in greater comfort. The robots will provide assistance to spectators in wheelchairs at the Olympic Stadium by carrying food and other goods, guiding people to their seats and providing event information. Power assist suits will be utilised in the backstage areas of venues and the Olympic Village to unload and transport heavy objects, including food and drinks, and for waste disposal, thus easing human workloads and providing a healthier, safer working environment. Q: What will be the legacy of Tokyo 2020? A: Our aim is to bring about positive change for Tokyo, Japan and the rest of the world. Events promoting and supporting the vision of the Games will be held nationwide. These will cover eight action ﬁelds: education, sport & health, culture, sustainability, urban planning, economy & technology, recovery, and nationwide beneﬁts & global communication.  42 OLYMPIC REVIEW  Below Technology will provide assistance to spectators in wheelchairs  Tokyo 2020 will be the ﬁrst Games modelled on the provisions of Olympic Agenda 2020 in terms of sustainability. We aim to be a role model for future Games. For Tokyo 1964, we were very focused on creating physical infrastructure, such as the bullet train network and highways. While these were very helpful at the time of the  ‘WE WANT THESE GAMES TO INSPIRE A LEGACY OF DIVERSITY AND INCLUSIVITY FOR JAPAN’ TOSHIRO MUTO, TOKYO 2020 CEO  Games, people are still beneﬁtting from these infrastructures. For 2020, our goal is to similarly enrich the lives of future generations. However, we will take a different approach this time. We want these Games to remove emotional barriers and inspire a legacy of diversity and inclusivity for Japan. This is an opportunity to see how all people, regardless of race, religion or physical attributes, can motivate and inspire those around them. We believe that a barrier-free Games where Japan welcomes the world with open arms will leave a positive legacy for the future. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.mobilityforall.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:39px;left:684px;width:94px;height:16px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "MobilityForAll.com  W H E N W E A R E F R E E TO M OV E , A N Y T H I N G I S P O S S I B L E ."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale\" id=\"44-title\" style=\"top:221px;left:67px;\" src=\"/112/static/_content/44-title.png\">\n        \n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/uOo_gFjECIQ')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:250px;top:733px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg44Anim = new TimelineMax();\n          pg44Anim.fromTo(idOf(\"44-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg44Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  PUBLIC PROVIDE HELPING HAND FOR SUSTAINABLE OLYMPIC MEDALS While most people will never experience what it’s like to win an Olympic medal, the Olympic Games Tokyo 2020 have at least given members of the public the chance to contribute to the making of one. Through its innovative Tokyo 2020 Medal Project, the Tokyo 2020 Organising Committee launched a landmark recycling initiative that collected unwanted electronic devices from Japanese residents in order to manufacture the 5,000 medals that will be awarded at next year’s Games. A total of 78,985 tons of discarded devices were collected, including approximately 6.21 million used mobile phones, along with digital cameras, handheld games consoles and laptops. The precious metals from these devices were then extracted, with 30.3kg of gold, 4,100kg of silver and 2,700kg of bronze being melted down for use in the medals. The project marked the first time in Olympic history that members of the public had been invited to directly contribute to the  44 OLYMPIC REVIEW  making of the medals that athletes will be competing for at the Games. The designs of the medals themselves were unveiled on 24 July as part of celebrations to mark the “One Year to Go” milestone. Designed by Junichi Kawanishi, director of the Japan Sign Design Association and the Osaka Design Society, and selected following a nationwide competition open to both professional designers and design students, the medals reflect patterns of light in order to symbolise the energy of the athletes and those who support them. “It is a great honour that my design was selected for the Tokyo 2020 Olympic medal,” Kawanishi said. “With their shining rings, I hope the medals will be seen as paying tribute to the athletes’ efforts, reflecting their glory and symbolising friendship.” ■  4,100kg of silver collected"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  6.21m More than six million mobile phones collected  30.3kg  of gold collected  78,985  tons of used mobile phones and other small electronic devices  2,700kg of bronze collected  5,000  medals manufactured using collected recycled metals  OLYMPIC REVIEW 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 46-title\" style=\"top:473px;left:115px;\" src=\"/112/static/_content/46-title.png\">\n        <img class=\"halfScale 46-title\" style=\"top:610px;left:115px;\" src=\"/112/static/_content/46-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg46Anim = new TimelineMax();\n          pg46Anim.staggerFromTo(cOf(\"46-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg46Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ONE YEAR TO GO  INNOVATION, FLEXIBILITY AND YOUTH GRUFFUDD OWEN LOOKS AT THE EXCITING NEW SPORTS JOINING THE OLYMPIC ROSTER FOR TOKYO 2020 AND ASKS THOSE INVOLVED WITH THE PREPARATIONS ABOUT THEIR HOPES AND EXPECTATIONS  L  and and sea, indoor and outdoor, vertical and horizontal – the new sports featuring on the programme at Tokyo 2020 promise to make it the most exciting edition of the Games yet, with a focus on innovation, flexibility and youth. While Olympic Agenda 2020 commits to moving from a sport-based to an event-based programme, the inclusion of skateboarding, surfing, sport climbing, karate and baseball/  46 OLYMPIC REVIEW  softball – made possible by reforms allowing host cities to propose the addition of new sports – represents a bold move by the IOC to engage with the younger generation of sports fans without impacting the schedule or structure of the Games. Here, Olympic Review profiles each of the five new sports – exploring their origins, the views of their biggest advocates, and what they will add to the greatest sporting stage."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WOMEN ONE YEAR IN SPORT TO GO  SPORT CLIMBING  DID YOU KNOW? No gloves or hand protection are allowed in sport climbing, so the athletes must rely on their bare hands  The newest of the sports profiled, sport climbing was born in Italy in 1985 after the celebrated climber Andrea Mellano and sports journalist Emanuele Cassarà decided to bring together some of the world’s best climbers for a competition in the Olympic town of Bardonecchia, attracting thousands of spectators. In just 35 years it has made its way to the Olympic Games, which is testament to the hard work of the International Federation of Sport Climbing (IFSC), created in 2007. Each athlete will compete in a total of three disciplines – speed climbing, bouldering and lead climbing – after which the combined results will determine the final rankings. Like skateboarding, the competition will be staged in temporary venues in urban settings, marking a historic step in bringing the Games to young people and reflecting the trend of urbanisation of sport. “I think we will see a lot more young people become interested and try out climbing thanks to Tokyo 2020,” says Frenchwoman Charlotte Durif, a multiple world champion in sport climbing who witnessed the sport’s first Olympic experience at Buenos Aires 2018, where she was an Athlete Role Model. “It’s a sport that makes you dream and is really fun to take part in with friends, while also being simple to set up. You don’t need thousands of things, you just need three handles on a wall and that’s it, you can start climbing. It’s a very inclusive sport; it’s a school of life in many ways.”  OLYMPIC REVIEW 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/taIbtReDrQU')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:306px;top:623px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  SKATEBOARDING Although there is no definitive account of the birth of skateboarding, it is widely believed that the sport began on the West Coast of the USA during the 1940s by Californian surfers looking for something to ride whenever they were unable to catch the waves. The original skateboard – a rudimentary wooden board with metal wheels – gradually developed into a more sophisticated piece of kit, with plastic replacing metal, and by the 1990s skateboarding had become a popular street activity the world over, spawning its own distinct counterculture. As the professionalisation of the sport grew, so too did the calls for it to be added to the Olympic Games. There will be two events in both gender categories at its debut outing in Tokyo: street and park. “Tokyo has been receptive to our ideas and the creativity we’re putting into the field of play,” says Gary Ream, Chairman of the World Skate Skateboarding  48 OLYMPIC REVIEW  Commission. “They’re very precise in the organisation, and it’s rewarding as they’re listening to what we believe is needed for it to be done in the right way. Hopefully the end result will be something that the kids on the street respect the Olympic Games for doing. “There are many things left to do. We’re following a proper timetable, and we’ve calculated a schedule and our progress. The pace will be picking up in the final year before the Games, there’s no doubt about it. It’s about moving forward and dilating the details in respect to what we need to do to represent skateboarding.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DID YOU KNOW? The competition skateparks will be open for public use during the Games  OLYMPIC REVIEW 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  KARATE The roots of karate – which literally means “empty hand” – can be traced to Okinawa during the time of the Ryukyu Dynasty. After its introduction to mainland Japan in the 1920s, the sport spread worldwide following the Second World War and penetrated popular culture in the latter half of the 20th Century thanks to the enormous success of martial arts films such as The Karate Kid. Karate at Tokyo 2020 will consist of two disciplines, kumite and kata, with a total of eight gold medals up for grabs. The competition will be held at the iconic Nippon Budokan, a legacy venue from the Tokyo 1964 Games. “Tokyo for us is a dream,” says Davide Benetello, chairman of the World Karate Federation Athletes’ Commission. “These Games will take place exactly 50 years after our first World Championships in the same country, in the same city and also in the same location! We are very proud of our journey to this point. Karate is very popular in Japan, and we are sure our values will shine through to the supporters and spectators. “Tokyo 2020 will be a big boost for karate. It will help people to understand how the rules work, how spectacular it is as a sport, but most importantly how safe it is. It’s a combat sport, but we operate very safely.”  50 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  DID YOU KNOW? The uniform worn by athletes when competing in karate is called a “gi”  OLYMPIC REVIEW 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  SURFING The practice of catching waves existed long before it was popularised by the Californians. Ancient Polynesians in Tahiti and the Hawaiian Islands are known to have surfed, and it was a native of the latter archipelago – Duke Kahanamoku, winner of three Olympic swimming gold medals representing the USA – who was regarded as the father of modern surfing, expressing his desire for his beloved sport to be included in the Games as early as 1912.  52 OLYMPIC REVIEW  More than 100 years later and surfing will be part of the Olympic programme for the first time, with men’s and women’s shortboard events taking place in the open sea at Tsurigasaki Beach. Speaking at a four-day test event held at the beach in July, International Surfing Association (ISA) Executive Director Robert Fasulo expressed confidence that his sport will put on a show to remember at Tokyo 2020. “We depend on Mother Nature, we depend on the natural  conditions as they present themselves,” he says. “We are very confident, and part of the reason why we’re here in this period is to see how the conditions are running during the format. “The biggest three lessons [from the test event] were that the event format works, the waves are absolutely up to standard to run a high-quality, world-class event, and we can innovate a little bit in the way we present the sport.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  DID YOU KNOW? Surﬁng is a hugely popular sport in Japan, with around two million recreational surfers"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  BASEBALL/SOFTBALL Of all the new sports at Tokyo 2020, baseball/softball is the only one that has previously featured at the Olympic Games. Baseball appeared intermittently since as far back as St Louis 1904 before becoming an official Olympic sport at Barcelona 1992, while softball’s Olympic debut came at Atlanta 1996. Although both  54 OLYMPIC REVIEW  disciplines were voted off the Olympic programme after Beijing 2008, baseball’s huge popularity in Japan made it an obvious choice for the Tokyo 2020 Organising Committee to propose for inclusion at next year’s Games. Six teams will compete in the men’s baseball event and a further six in softball,  which is reserved for female athletes only. “On a global level, I’m very much looking forward to laying the foundations for the future of baseball and softball in the Olympic Movement,” says Justin Huber, co-chair of the World Baseball Softball Confederation (WBSC) Athletes’ Commission.  “At the WBSC, we really want to showcase what our sport can do. “On a personal level, this is my dream. I missed out on the silver medal-winning Australian team at Athens 2004 due to injury, so I see it as my way of having my Olympic moment. This is the Olympic Games, and there is nothing else like it.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "ONE YEAR TO GO  DID YOU KNOW? The most successful team in Olympic baseball history is Cuba with three gold medals and two silver medals  OLYMPIC REVIEW 55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 56-title\" style=\"top:397px;left:67px;\" src=\"/112/static/_content/56-title.png\">\n        <img class=\"halfScale 56-title\" style=\"top:511px;left:67px;\" src=\"/112/static/_content/56-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg56Anim = new TimelineMax();\n          pg56Anim.staggerFromTo(cOf(\"56-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg56Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "THROUGH THE LENS JAPAN AT THE GAMES  THROUGH THE LENS WITH TOKYO 2020 FAST APPROACHING, WE TAKE A PICTORIAL LOOK AT THE HOST COUNTRY’S LONG AND CHERISHED ASSOCIATION WITH THE OLYMPIC GAMES  Stockholm 1912 In the early 20th century, the modern Olympic Games were still welcoming many new countries to each edition, and it was in 1912 that Japan made its debut, in Stockholm. The Japanese delegation had only two representatives, both in athletics. Shizō Kanakuri participated in the marathon, while Yahiko Mishima (pictured) competed in three disciplines: 100m, 200m and 400m.  56 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS JAPAN AT THE GAMES  01 Antwerp 1920 Japan’s second appearance at the Games brought its first Olympic medals, coming in the men’s singles and doubles tennis; both medals were silver. Perhaps more significantly, the country increased its number of athletes greatly; from just two in 1912 to 15 in 1920. All the Japanese athletes took part in the opening parade of nations at the Opening Ceremony, as pictured.  02 Rome 1960 Gymnast Takashi Ono (pictured) was the flagbearer for Japan at Rome 1960, having won five gold medals in Melbourne four years previously. At the iconic Baths of Caracalla venue in Rome, Ono clinched a further six medals, three of which were gold. He was then chosen to take the Olympic oath on behalf of his country when the Games were first hosted in Tokyo – and Asia – in 1964.  03 Tokyo 1964 While Takashi Ono had the honour of taking the Olympic oath, the role of torchbearer was symbolically given to Yoshinori Sakai, a sprinter who was born on the day of the bombing of Hiroshima during World War II. Though he did not compete at the Games, Sakai’s involvement represented his country’s commitment to peace and harmony since the conclusion of the war.  58 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS  01  02  03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS JAPAN AT THE GAMES  01  02  60 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THROUGH THE LENS  01 Sapporo 1972 In April 1966, Sapporo’s bid to host the Olympic Winter Games was approved, after it saw off bids from Banff (Canada), Lahti (Finland) and Salt Lake City (USA). Consequently, the city found itself at the centre of the Olympic movement as hundreds of athletes descended on the northern Japanese island of Hokkaido.  02 Nagano 1998 After the success of Sapporo 1972, the Winter Games returned to Japan, this time to the city of Nagano. Here, Japanese pairing Aya Kawai and Hiroshi Tanaka perform their ice dance routine over the official logo for the Games.  03  04  05  03 London 2012 Kaori Icho established herself as one of the most successful wrestlers in Olympic history, as she won gold in the 63kg event for the third successive Games. Icho went on to further enhance her legendary status in Rio four years later, becoming the first female in any sport to win four consecutive gold medals at the Olympic Games.  04 Rio 2016 Japan’s only gold medal in badminton was won at Rio 2016 in the women’s doubles. Misaki Matsutomo (pictured) and Ayaka Takahashi were the victorious pair, overcoming a Danish duo in the final. In Rio, Japan won its record haul of Olympic medals: 41 in total.  05 Tokyo 2020 Japanese sport climber Akiyo Noguchi shows off her skills at the IFSC-ACC Asian Championships at Kurayoshi Sports Climbing Centre. Sport climbing will make its full Olympic debut at Tokyo 2020 and Noguchi is hoping to make history.  OLYMPIC REVIEW 61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  TOKYO 2020 VISION  62 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 63-title\" style=\"top:207px;left:149px;\" src=\"/112/static/_content/63-title-1.png\">\n        <img class=\"halfScale 63-title\" style=\"top:424px;left:350px;\" src=\"/112/static/_content/63-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg63Anim = new TimelineMax();\n          pg63Anim.staggerFromTo(cOf(\"63-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg63Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  CHLOE ESPOSITO  CHLOE ESPOSITO DRAMATICALLY STORMED THROUGH THE FIELD FROM SEVENTH PLACE TO CLINCH MODERN PENTATHLON GOLD AT THE OLYMPIC GAMES RIO 2016, BUT IT HASN’T BEEN PLAIN SAILING FOR THE AUSTRALIAN SINCE THEN. HERE, SHE SPEAKS TO MICHAEL STONEMAN ABOUT SPONSOR STRUGGLES, STEPPING AWAY FROM THE SPORT AND GETTING BACK TO THE TOP IN TOKYO  I  t may be a cliché, but it’s fair to say that Chloe Esposito has a smile that could light up any room. Or, indeed, any Olympic podium as it did at the Olympic Games Rio 2016, as the bright-eyed, curly-haired Australian received her hard-earned modern pentathlon gold medal. Grinning from ear to ear, the then 24-year-old had fulﬁlled her childhood dreams by stepping onto the top of the podium – dreams that were sown at the age of 11, when her Olympian father and coach, Daniel, ﬁrst showed her the keepsakes of his own Olympic adventure as a modern pentathlete at the Los Angeles 1984 Games. “I can't put into words how I actually felt on the day and even now I get a bit emotional just thinking about it at all,” explains Esposito, recalling the moment she won gold after a near ﬂawless  performance in the combined laser run saw her move through the ﬁeld to clinch victory, having started the ﬁnal discipline in seventh position and seemingly out of contention. “I just can't believe it all came together; all the hard work over the previous years, from when I was a little girl, everything led up to that moment. It just all came together at the perfect time. “You set goals for yourself and it might not happen in a week, it might not happen in a year. It took me 13 years to achieve my goal of winning a gold medal for Australia. So, you've just got to keep working at it. And that's what I did. Looking back, everything in my life led up to that, and I couldn't have been happier.” But the elation she experienced on the podium soon faded. A newly  crowned Olympic champion returning to sports-mad Australia would usually expect to be inundated with sponsors willing to help fund their next tilt at glory. But despite that beaming smile and bubbly personality that would be any marketer’s dream, Esposito quickly found herself back on the fringes of the country’s sporting consciousness – and once again relying on her parents to support her training. “The ﬁrst six months after the Olympics was crazy for me; I had something on every day, whether it was a media interview or a talk or an appearance somewhere, and then after that it was nothing, just crickets,” she explains. “I literally thought as soon as I got off that plane [from Rio] that people would be offering to sponsor me left, right and centre. But no, it wasn't the case.  OLYMPIC REVIEW 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 64-quote\" style=\"top:315px;left:540px;\" src=\"/112/static/_content/64-quote.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(cOf(\"64-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  “It was hard. I had to accept that nothing lasts forever and what happened [in Rio] was now in the past; I’d created some beautiful memories but it was time to get on with my next goal. I did receive some funding from Sport Australia, but I’m lucky that the support from mum and dad has been endless as well.” Leading in to Rio 2016, Esposito found herself so reliant on her parents that she would  even have to ask them for money to go out and get a coffee with her friends. “It was embarrassing because I was 24 and I still had to ask them for money like that, but I wanted to achieve this goal, and they were so supportive of it.” After returning from Rio with that goal accomplished, Esposito decided to step away from competition for most of 2017, enjoying  time at home with her family and marrying her partner, Matthew. And despite being an Olympic champion, her feet were soon ﬁrmly back on the ground when she found herself needing to ﬁnd a job to support herself. “I was working at the shooting range where they had the Sydney Olympics,” she says. “The funding [from Sport Australia] hadn’t come through yet, so I just had to get a job. I didn’t  ‘I DIDN’T EVEN KNOW IF I WANTED TO KEEP TRAINING ANYMORE, I REMEMBER TRYING TO BOOK MY FLIGHT TO GO BACK HOME’ CHLOE ESPOSITO mind working; it was nine-to-ﬁve, sometimes with a night shift, and I enjoyed it. It was nice doing something else and I wasn’t in full-time training because I was taking that year off.” After enjoying what she describes as an “amazing” year at home, Esposito began preparing for her return to competition in 2018, but the strain of having to base herself in Hungary for training quickly took its toll. “Getting back into training was so hard, but I actually didn't mind that; that was ﬁne. The hardest part was, having been home for so long, I then had to go back overseas, away from my friends and family. That's what was really tough for me, just having to get used to that routine again, being away from everyone and being in a country where people don’t speak English. I had to really adjust to living overseas again, especially during the European winter. It’s cold and there’s no sun. We’d leave the house at ﬁve o'clock in the morning, and it's pitch black. And then the sun is going back down at about 3.30pm. It was depressing.” The smiles of the Rio podium seemed furthest away for Esposito during Christmas at the end of 2017, when she found herself in Budapest questioning whether she even wanted to continue in the sport. “I just didn't want to be there,” she recalls. “I didn’t even know if I wanted to keep training"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 65-quote\" style=\"top:607px;left:336px;\" src=\"/112/static/_content/65-quote.png\">\n\n        <a onClick=\"Publish.openVideo('https://www.youtube.com/embed/oytMbzI-8t8?start=1')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:50px; height:50px;left:291px;top:333px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",

    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim.fromTo(cOf(\"65-quote\"), 0.6, {y:50, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n        }\n    \n        function onPageLeave() {\n          pg65Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Far Left Esposito fought hard to make her way to Rio 2016 Left She ﬁnished seventh at London 2012 Right Achieving gold and an Olympic record in Rio  anymore. I remember trying to book my ﬂight to go back home, because I said, ‘That's it for me; I'm tired of being away from everyone’.” The career of the reigning Olympic champion very nearly ended there and then, if not for a fortuitous internet glitch. “I always believe in signs and things happening for a reason, and I tried to book my ﬂight three times and it wouldn't work,” she explains. “So then I really just sat down and thought about it and I said, ‘Chloe, you've put in so much work and so much effort. Is this really what you want?’ And I decided I’m just going to stick it out.” That decision proved to be the right one, as Esposito went on to enjoy her most successful season, securing her ﬁrst World Cup victory in Kecskemét (Hungary) before claiming gold at the World Cup Final after a typically determined ﬁght-back, as she overhauled Hungary’s 2016 world champion Sarolta Kovács in the closing laser run event. Those results helped her climb to the top of the world rankings for the ﬁrst time, but she decided to sit out the 2018 World Championships due to a niggling hamstring injury and instead return to Australia for some more down time. “The start of that year had been a very tough time for me, and then I ended up having the best season of my life,” she says. “When you  ‘I CAN’T PUT INTO WORDS HOW I ACTUALLY FELT ON THE DAY AND EVEN NOW I GET A BIT EMOTIONAL JUST THINKING ABOUT IT AT ALL’ CHLOE ESPOSITO  go through those tough times, it's just so hard. But I think that helps. I always say you need to have tough times to have really good times. And once I got past that, I got in this zone that I've never been in before. The result in Rio had boosted my conﬁdence so much and I just knew in my head that I was the best. I know  it sounds really cocky, but I knew I’d trained harder than anyone else and I knew I could go and get those results.” But the smiles proved to be short-lived once again, as Esposito’s hamstring injury turned out to be more serious than ﬁrst thought, forcing her to undergo surgery to reattach the muscle  OLYMPIC REVIEW 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title\" style=\"top:138px;left:67px;\" src=\"/112/static/_content/66-title.png\">\n        <img class=\"halfScale 66-title\" style=\"top:223px;left:67px;\" src=\"/112/static/_content/66-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim.staggerFromTo(cOf(\"66-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 0.3, 1)\n        }\n    \n        function onPageLeave() {\n          pg66Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "TOKYO 2020 VISION  TALKING TOKYO Chloe Esposito onÉ Her love of Japan My favourite country besides Australia is Japan. I've been to Tokyo twice before and also to Chiba, which was beautiful. I love Japanese food and I just love the vibe of the whole place; the way people dress and how busy and bustling it is at night.  Tokyo’s plans for the Games I think it will be amazing because the people there are so polite, so friendly and so organised. It's also so clean there. I think they'll put it on a really good show.  The modern pentathlon venue This is the ﬁrst time for modern pentathlon that they’re having “one ticket, one seat” at the Games, which means people can see all of the disciplines in one venue. That’s really cool and I’m excited about that; it will make it more exciting for fans and it means people can watch the whole show.  66 OLYMPIC REVIEW  tendons to her pelvic bone at the start of this year. The procedure would rule her out for the whole of 2019. “Towards the end of last season I started feeling a few niggles in my leg, and it took a while to ﬁgure out what it was,” she explains. “We found out I needed to have the operation and it's been pretty tough, especially after having such an amazing season last year. The ﬁrst six weeks [after surgery] were like hell; I couldn't even sit because it was so painful. Basically all I could do was lie down. “The rehab has gone well but not being able to compete in the World Cups or the world championships is the worst. I’ve been trying not to look at the results, but then I ﬁnd myself wanting to see how everyone else is doing. So I end up watching it all. I’m not upset to see other people doing well – that’s great for them – but I’m upset I'm not there competing with them. It's hard knowing what I can do and just not being able to do it at the moment.” With Tokyo 2020 less than a year away, the injury has certainly dented Esposito’s preparations, but she is conﬁdent of being back to her best when the event gets underway in the Japanese capital, especially having overcome a similar situation in the lead-up to Rio 2016, when she suffered an Achilles injury just months before the Games. “This year obviously hasn't been that great for me, but it's similar to what happened before Rio,” she says. “I had the injury, and going  through those hard times, I know something good has to happen. I work too hard for this and my whole team does as well. If it's meant to happen, it's meant to happen. But with one year to go, it's so, so exciting. “I don’t want to sound cocky, but I know I can do it again. I’m doing everything at the moment to get back to where I need to be. I'm going to put everything into it and then we’ll see what I can do on the day in Tokyo. Hopefully, ﬁngers crossed, it will be gold.” And if Esposito is to step onto the top of the podium again in Tokyo, we can look forward to seeing that beaming smile light up the Games once more. ■  Above Preparing for Tokyo with one year to go"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECORDING O LYM P I C D R E A M S  Since 1932, OMEGA has known that the Olympic Games is a stage for dedicated athletes to reach their dreams. That’s why ZHORYHRXUUROHDV2IÿFLDO7LPHNHHSHUDQG why we’re so passionate about providing trusted precision in every single event."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "68 OLYMPIC REVIEW"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-title\" style=\"top:293px;left:348px;\" src=\"/112/static/_content/69-title.png\">\n        <img class=\"halfScale 69-sub\" style=\"top:448px;left:350px;\" src=\"/112/static/_content/69-sub.png\">\n        <div class=\"addContentLink\" style=\"top:445px;left:528px;height:16px;width:93px;\">\n          <a href=\"https://www.olympicchannel.com/en/original-series/detail/all-around/all-around-season-season-1/episodes/all-around-the-tokyo-2020-journey-begins/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim.fromTo(cOf(\"69-title\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"69-sub\"), 0.6, {y:-30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut, onCompelte: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg69Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "INSIDE THE OLYMPIC CHANNEL  ALL AROUND THE OLYMPIC CHANNEL’S LATEST ORIGINAL SERIES TAKES VIEWERS ON AN INTRIGUING REAL-TIME JOURNEY WITH THREE OF THE WORLD’S LEADING GYMNASTS AS THEY PLOT THEIR COURSE TO TOKYO 2020. BY CONOR KETLEY  W  Pictured Chen Yile is one of three female gymnasts featured in the Olympic Channel’s newest original series  ith the next Olympic Games set to burst into life in less than a year in Tokyo, it seems apt that the Olympic Channel’s latest cutting-edge series kicks off in the Japanese capital. All Around is the behind-the-scenes story of three of the world’s ﬁnest female gymnasts and their ongoing journey to the Games. Morgan Hurd, of USA, launches the ﬁrst episode with victory in the Tokyo leg of the 2019 FIG Artistic Gymnastics World Cup in April, while Angelina Melnikova and Chen Yile, of Russia and China respectively, document their equally relentless progress. Produced exclusively for the Olympic Channel by award-winning Noah Media Group, the series will  run for about a year and consist of 13 episodes, 12 to be broadcast before the Games and the ﬁnal one to be broadcast after Tokyo 2020. Beginning with Hurd’s appearance in Japan, the audience’s journey with all three athletes will eventually come full circle, climaxing at the Ariake Gymnastics Centre, the host venue for gymnastics at Tokyo 2020, next year. Camera crews have been granted unprecedented access to the three athletes’ lives during this period, as they explore the highs and lows of chasing success on the biggest stage of all. Not only will viewers gain insight into the gruelling training regimes of the gymnasts, but also how their personal lives play out relative to the quest for Olympic glory.  OLYMPIC REVIEW 69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INSIDE THE OLYMPIC CHANNEL  “I hope to bring about a new understanding for how mentally and physically challenging gymnastics is,” Hurd told the Olympic Channel prior to ﬁlming. And we get a glimpse of just how challenging it can be when Hurd’s head coach Slava Glazounov puts the American through her paces in a training session in episode one. The differing backgrounds of the three gymnasts promise compelling stories in the months to come. For Morinari Watanabe, IOC Member and President of the International Gymnastics Federation (FIG), this fascinating series will provide viewers with a new glimpse into the world of gymnastics, as well as exploring the cultural differences between the women. “These three gymnasts are from different parts of the world and we will see whether they train in similar or different ways and how their lives compare on and off the mat,” says Watanabe. “All three have said this is the most important year of their lives and the fact that we will get to see all the highs, and I am sure some lows, is wonderful.” All Around’s audience will be able to follow the gymnasts’ progress in regular monthly instalments of the series via the Olympic Channel. Expect a rollercoaster of emotions on the way to the Games: the athletes must ﬁrst ﬁght to reach the 2019 World Artistic Gymnastics Championships, which take place in Stuttgart (Germany) in October, before appearing at a number of regional tournaments in order to qualify for Tokyo 2020. In addition to the primary content provided by the Olympic Channel, Hurd, Melnikova and Chen will be sharing additional clips and diary entries via their social media channels, which will keep followers informed in between the main episodes. “Not only will the series reveal the level of dedication, commitment  70 OLYMPIC REVIEW  Morinari Watanabe IOC Member and President of the International Gymnastics Federation (FIG)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "and focus it takes to be an Olympic gymnast, but it will also show how much fun gymnastics is,” added Watanabe. “[Sports fans] will discover they are similar to these amazing athletes and that is a very positive thing.” The series takes its name directly from the blue riband event that combines the four main women’s disciplines in artistic gymnastics: beam, ﬂoor, uneven bars and vault. Neither Hurd, 18, nor Chen, 17, have featured on the Olympic stage before, but Melnikova, 19, won a silver medal at Rio 2016 in the team all-around event. From the ﬁrst episode, which premiered on 6 August, it becomes clear how important this journey will be to  Clockwise from far left Melnikova at the European Championships; Hurd perfoming at the Pan American Games; Chen preparing for a routine  OLYMPIC REVIEW 71"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:348px;left:465px;width:105px;height:13px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "INSIDE THE OLYMPIC CHANNEL  all of them. Chen’s story begins with an emotional reunion with her family, who she has not seen for two years due to training and competition; Hurd gives us an insight into her strict training plan as she prepared for the Pan American Games; and Melnikova is at the centre of a promotional event ahead of the European Games in Minsk (Belarus), where she went on to win four medals. Tokyo 2020 is also set to be the Games at which the highest percentage of female participants compete, due to  reach 48.8 per cent, up from 45.2 per cent at Rio 2016. All Around is therefore a celebration of women in sport with its three female protagonists who enthral viewers with their skilful performances and engaging personalities. “It is worth mentioning that gymnastics has a very positive, femalefocused gender balance, which is quite rare in sport right now,” Watanabe said. “Of course, we have a lot of fantastic male participants from grassroots to elite level, but the larger proportion  of gymnasts are female, which is something to celebrate.” The beauty of All Around is that we do not know what is to come; the future of the gymnasts is unknown. One thing we can be sure of is that their journey to Tokyo will be one worth watching. ■ All Around can be seen on olympicchannel.com, its mobile apps or connected TV devices  WHAT THEY SAY  Morgan Hurd, USA “I hope to share with viewers a behind the scenes look at what really goes on off the competition ﬂoor. Fans are going to get to see All Around in the most important year of my life.”  72 OLYMPIC REVIEW  Chen Yile, China Angelina Melnikova, Russia “I’m so excited about this series. The cameras will be following me everywhere, and I’m really looking forward to sharing what it’s like to be a top gymnast.”  “I look forward to the next 12 months as I work hard day-by-day to achieve my dream of representing my country proudly at Tokyo 2020.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.olympicchannel.com\" target=\"_blank\">\n          <div class=\"addContentLink\" style=\"top:696px;left:376px;width:273px;height:35px\"></div>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 74-title\" style=\"top:228px;left:64px;\" src=\"/112/static/_content/74-title.png\">\n        <img class=\"halfScale 74-sub\" style=\"top:355px;left:66px;\" src=\"/112/static/_content/74-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg74Anim = new TimelineMax();\n          pg74Anim.fromTo(cOf(\"74-title\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"74-sub\"), 0.6, {y:-30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg74Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "MY GAMES  MY GAMES  MICHAEL JOHNSON MICHAEL JOHNSON BOUNCED BACK FROM DISAPPOINTMENTS IN 1988 AND 1992 TO BECOME ONE OF THE GREATEST SPRINTERS IN OLYMPIC HISTORY. HERE, HE TELLS MICHAEL STONEMAN ABOUT THE STANDOUT MEMORIES OF AN INCREDIBLE OLYMPIC CAREER  THE GAMES NEVER SEEMED POSSIBLE The first time I remember watching the Olympic Games was in 1984, when they were held in Los Angeles. I was 16 and there was a kid, Ray Martin, who I had to run against every weekend, who made the US team as an alternate. At that point, I had no dreams of ever going to the Games myself; it wasn’t something that seemed possible for me. I wasn’t a teenage phenomenon. I was just out there having fun with the sport and hoping that, maybe one day, I’d be able to beat Ray Martin. And I did, eventually.  NO LONGER A DREAM Once I went to college and had real coaching for the first time, I improved dramatically. By 1988, I was running times that could have won the US Olympic trials. Unfortunately, I got injured at the end of the collegiate season. The times I was running during the year would have put me on the US team for Seoul, so that was disappointing, but now I knew I could get there. I thought, “You can be there. You’ve got to keep working hard.” It was no longer a dream, but I still had to go out and make it happen.  74 OLYMPIC REVIEW  UNDER PRESSURE I had spent 1990 and 1991 doing things that had never been done before; the first person to be ranked number one in the world in 200m and 400m, “Athlete of the Year” in my first year as a professional, winning the world championships by the greatest distance since Jesse Owens. So I went into 1992 thinking, “The pressure’s on. I should win the Olympic Games this year.”  MY BIGGEST DISAPPOINTMENT Unfortunately, I got food poisoning in the lead-up to Barcelona, but I was thinking I’d be ready to race by the second week. When the competition started, I could"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MY GAMES  Pictured Michael Johnson made history with 200m and 400m gold at Atlanta 1996  OLYMPIC REVIEW 75"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <h1 id=\"76-no1\" class=\"abs 76-no hn-bde\" style=\"left:214px;top:735px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 3 }' ></h1>\n        <h1 id=\"76-no2\" class=\"abs 76-no hn-bde\" style=\"left:306px;top:735px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 4 }' ></h1>\n        <h1 id=\"76-no3\" class=\"abs 76-no hn-bde\" style=\"left:573px;top:736px; font-size: 2.2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 8 }' ></h1> \n        <a href=\"https://www.olympicchannel.com/en/original-series/detail/legends-live-on/legends-live-on-season-season-1/episodes/where-are-they-now-michael-johnson-s-legend-lives-on/\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:40px; height:40px;left:288px;top:384px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#000\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#000\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        pg76Anim = new TimelineMax();\n        pg76Anim.fromTo(cOf(\"76-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[0]);}}, 1)\n                .fromTo(cOf(\"76-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[1]);}}, \"-=0.3\")\n                .fromTo(cOf(\"76-no\")[2], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"76-no\")[2]);addContentLinks();}}, \"-=0.3\")\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n          pg76Anim.stop();\n          resetNumbers('76-no');\n        }\n      ",
    "searchText": "MY GAMES  tell in my first round that something was wrong. And it did not get better with each round [Johnson was eliminated in the semi-finals]. I just wasn’t able to go out there and compete, and none of the guys who won the medals had ever beaten me before. That was the biggest disappointment of my career. As an athlete in an Olympic sport, you know that when you get that opportunity once you may not get that lucky again. I was in the 4x400m relay as well, and won the gold as a part of that team, but at that time it didn’t mean much to me at all, even though I now cherish that medal. It was tough being reminded every day that I didn’t come home with the [individual] gold medal.  Then, of course, seeing the time, and the margin with which I had broken my own world record, I was just over the moon.  MY FINAL GAMES After Atlanta, my main focus was breaking the 400m world record. I was able to do that in 1999, so then I knew that 2000 would be my last year of competition. That allowed me to go in to Sydney and just focus on the Games. I was also able to say, “This is going to be it for me. I’ve done enough.” I knew that Sydney would be the end, so I was really able to enjoy it. No one had ever repeated as 400m Olympic champion, so I thought, “Well, that should be me then. That’ll be my goal.” I was injured, so I didn’t get to actually run any races at all between the trials and the Games. Fortunately, I was able to get there relatively healthy. It wasn’t my best race, but it was enough to win.  SAVOURING THE MOMENT There was a tremendous amount of pressure going into Atlanta 1996. I always knew it was going to be like that, but my best performances came when I was under pressure. There aren’t many athletes like that, which I think was why I was able to deliver my best performances at world championships and Olympic Games. I knew that going in and had prepared for it. The 400m was always going to be the easier of the two events. Winning my first individual medal was fantastic, but then I was already starting to think about the 200m. I was talking to [Great Britain’s] Roger Black, the silver medallist who was a friend of mine, and he could tell. He said to me, “Michael, you’ve got to savour this moment.” I didn’t give it a second thought until we were walking out to the podium.  Above On the way to a fourth gold at Sydney 2000  And when I saw the reaction of the crowd, I did actually allow myself to just savour that moment. I then started thinking about the 200m in Barcelona, and about 1988. And then the tears started flowing.  MAKING HISTORY When I crossed the finish line in the 200m, I felt all sorts of emotions. I was obviously just elated that I had actually completed the double. I was relieved because there was a tremendous amount of pressure, and while I enjoy pressure, it’s tough to deal with it for that long. I didn’t want to fail at what I said I was going to do. And with an overwhelmingly US crowd – who had already hung the medal around my neck – I was absolutely relieved as well.  WHAT THE GAMES MEAN TO ME Being an Olympian means that I’m able to be a part of a very, very special group. I think about some of the athletes who I competed against in the early rounds at the Games, like the first round of the 200m in Barcelona. There was a guy there who didn’t even know how to use the starting blocks. We were competing on completely different levels, but we ran that race together and then it was the end of his Games, but he is still an Olympian. He’s probably the same age as I am, and to this day it means just as much to him as it means to me. It’s an amazing experience to participate in the greatest sports spectacle in the world. ■  FACT FILE  Born 13 September 1967 in Dallas, USA  76 OLYMPIC REVIEW  3  Competed in three editions of the Olympic Games: 1992, 1996, 2000  4  Olympic gold medals  Barcelona 1992 4x400m relay  Atlanta 1996 200m and 400m  Sydney 2000 400m  8  IAAF World Championship gold medals  19.32s World-record time in the Atlanta 1996 200m final"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:138px;left:109px;\" src=\"/112/static/_content/78-title.png\">\n        <img class=\"halfScale 78-sub\" style=\"top:188px;left:109px;\" src=\"/112/static/_content/78-sub.png\">\n\n        <a onclick=\"Publish.openVideo('https://www.youtube.com/embed/gSBBLEDtWMg')\" target=\"_blank\">\n          <svg class=\"abs pulse animatedpulse pointer\" style=\"width:30px; height:30px;left:118px;top:344px\" version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"675px\" height=\"675px\" viewBox=\"0 0 675 675\" enable-background=\"new 0 0 675 675\" xml:space=\"preserve\">\n            <circle fill=\"none\" stroke=\"#fff\" stroke-width=\"30\" stroke-miterlimit=\"10\" cx=\"339.195\" cy=\"340\" r=\"321\"/>\n            <polyline fill=\"#fff\" points=\"558,356 207,563 207,117 \"/>\n          </svg>\n        </a>\n        <div class=\"addContentLink\" style=\"top:135px;left:106px;height:35px;width:443px;\">\n          <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/184660/the-olympic-stadiums-of-the-summer-games-from-athens-1896-to-tokyo-2020-the-olympic-studies-centre\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:265px;left:347px;height:121px;width:115px;\">\n          <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/207464/legacy-olympic-and-paralympic-games-rio-2016-organising-committee-for-the-olympic-and-paralympic-gam\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:683px;left:611px;height:137px;width:120px;\">\n          <a href=\"https://library.olympic.org/Default/doc/SYRACUSE/207568/the-history-of-the-olympic-games-and-the-ioc-athens-to-pyeongchang-1894-2018-david-miller\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.6, {x:50, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut, onComplete: addContentLinks}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OLYMPIC STUDIES  OLYMPIC STUDIES BOOK REVIEWS FROM THE IOC OLYMPIC STUDIES CENTRE – YOUR SOURCE OF OLYMPIC KNOWLEDGE; CONTACT US AT STUDIES.CENTRE@OLYMPIC.ORG OR VISIT OLYMPIC.ORG/STUDIES  OFF THE SHELF PYEONGCHANG 2018 OFFICIAL REPORT This report contains three volumes and a documentary film: “PyeongChang’s passion for new horizons”, available on YouTube. It records each phase of Games preparation from 2011 and suggests sustainable ways for the Republic of Korea and PyeongChang to contribute to the Olympic and Paralympic Movement in the long term. Volume 1, “Bid for PyeongChang 2018”, examines the bid process; the second is an “Official commemorative book” capturing the scenes from PyeongChang 2018; and the last, “PyeongChang 2018 Operations”, covers the preparation and outcome of the Games. Volumes 1 and 3 are bilingual English-French, while volume 2 is published separately in French and English.  LEGACY: OLYMPIC AND PARALYMPIC GAMES RIO 2016 This report by the Rio 2016 Organising Committee evaluates the legacy of the Rio 2016 Olympic and Paralympic Games, the first to be held in South America. Richly illustrated, it consists of six chapters. The report demonstrates how the Games leave a legacy that goes beyond sport and has resulted in various improvements in the country, extremely relevant for Brazilian society. The Olympic project resulted in an innovative urban regeneration plan, improvements to the transportation system, environment, science and technology, and contributed to economic and social development among the population.  Published by The PyeongChang Organising Committee for the XXIII Olympic Winter Games, 2019, 4 volumes and 1 film, in English and French.  Published by Organising Committee for the Olympic and Paralympic Games Rio 2016, 2018, 176 pages, in English.  LE SYSTÈME OLYMPIQUE : PASSÉ, PRÉSENT ET FUTUR : MÉLANGES EN L’HONNEUR DU PROFESSEUR JEAN-LOUP CHAPPELET Prefaced by IOC President Thomas Bach, this book consists of 16 original contributions, in French and English, in honour of Professor Jean-Loup Chappelet, an expert on modern-day Olympism. The three sections in the book correspond to the three major themes addressed by Chappelet during his career: Switzerland at the heart of the Olympic system; the governance and performance of Olympic organisations and sporting events; and the regulation of international sport. As a conclusion, Jean Camy focuses on MEMOS, described as a “learning community”, and looks at the role of Chappelet in the education of a number of leaders and managers in the Olympic Movement. Edited by Emmanuel Bayle. Published by Presses Polytechniques et Universitaires Romandes, 2019, 326 pages. ISBN 9782889153176, in French and English.  78 OLYMPIC REVIEW  THE HISTORY OF THE OLYMPIC GAMES AND THE IOC This book is a fascinating account of the history of the Olympic Games and the IOC. It is the story of the creation of the modern Olympic Games by Pierre de Coubertin, of its governing body, which was formed in 1894, and of the highs and lows of the Games themselves since the first edition in Athens in 1896. The 87 chapters cover each of the Olympic Games and are interspersed with linking chapters which highlight the moments that have marked Olympic history. David Miller looks at key issues such as the advent of television, the financing of the IOC, the ongoing fight against doping in sport, the birth of the Youth Olympic Games, Olympic Agenda 2020 and much more. Miller also tells the stories of the legendary competitors, and each chapter begins with a personal anecdote by an athlete or a key IOC figure. This new edition also features updated sections on PyeongChang 2018. Extensive appendices provide the list of IOC Members, Games results and medals tables. Author David Miller. Published by International Olympic Committee, 2019, 585 pages, in English."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 81-title\" style=\"top:198px;left:67px;\" src=\"/112/static/_content/81-title.png\">\n        <img class=\"halfScale 81-sub\" style=\"top:234px;left:66px;\" src=\"/112/static/_content/81-sub.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg81Anim = new TimelineMax();\n          pg81Anim.fromTo(cOf(\"81-title\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"81-sub\"), 0.6, {y:-30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.3\")\n        }\n    \n        function onPageLeave() {\n          pg81Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "OBITUARIES  PERNELL WHITAKER BRILLIANT AMERICAN BOXER WHO WON GOLD ON HOME SOIL AT THE OLYMPIC GAMES LOS ANGELES 1984  Legendary American boxer and Olympic gold medallist Pernell Whitaker has died, aged 55. Nicknamed “Sweet Pea”, Whitaker topped the podium in the men’s lightweight event at the Olympic Games Los Angeles 1984. The southpaw turned professional shortly after the Games and went on to become a world champion in four different weight classes as one of the sport’s most dominant fighters during the  late 1980s and 1990s. Whitaker retired in 2001 with a 40-4-1 professional record and was inducted into the International Boxing Hall of Fame in 2006.  KEN MATTHEWS  MONA-LIISA NOUSIAINEN  Ken Matthews, Olympic race walking gold medallist, has died at the age of 84. Representing Great Britain at Tokyo 1964, Matthews’ time of 1:29:34 in the men’s 20km walk was an Olympic record, while his record winning margin of 99 seconds remains unbroken to this day. He also clinched a gold medal at the 1962 European Athletics Championships and won the Lugano Trophy (now known as the IAAF World Race Walking Team Championships) in 1961 and 1963.  Finnish Olympic cross-country skier Mona-Liisa Nousiainen has passed away at the age of 36. She won two gold medals in the “Sprint C” category at the FIS World Cup events in Liberec (Czech Republic) and Sochi (Russia) in 2013. The former came in the individual event and the latter was won alongside compatriot Anne Kyllönen. Nousiainen represented her country at the Olympic Winter Games Sochi 2014 and secured five medals at the FIS Nordic Junior World Ski Championships.  LOWELL NORTH  DR KAREL WENDL  American sailor, Olympic gold medallist and entrepreneur Lowell North has passed away at the age of 89. A multiple world champion across four decades, North first won an Olympic medal in the dragon class at Tokyo 1964, earning bronze. His finest hour came four years later, when he landed gold at Mexico City 1968, in the Star class alongside Peter Barrett. North also founded North Sails, a successful sailing equipment company and was inducted into the National Sailing Hall of Fame in 2011.  Olympic historian Dr Karel Wendl has passed away, aged 88. One of the finest marathon runners of his generation, Wendl worked as a lawyer before emigrating to Mexico to work for the Organising Committee of the Olympic Games Mexico City 1968. After joining the IOC in 1983, the Czech climbed the ranks to become Head of the IOC’s Olympic Research Department and was an original member of the International Society of Olympic Historians. Wendl retired from the IOC in 1995 and received the Olympic Order a year later.  NAVID MOHAMMADI  Navid Mohammadi, karate gold medallist at the Youth Olympic Games Buenos Aires 2018, has died at the age of 18. Regarded as one of the sport’s most exciting young talents, the Iranian won the men’s kumite +68kg competition in karate’s debut Olympic appearance. The karateka also won multiple youth medals at national and continental level.  OLYMPIC REVIEW 81"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top:103px;left:67px;\" src=\"/112/static/_content/82-title.png\">\n        <img class=\"halfScale 82-sub-1\" style=\"top:150px;left:66px;\" src=\"/112/static/_content/82-sub-1.png\">\n\n        <img class=\"halfScale 82-sub-2\" style=\"top:210px;left:66px;\" src=\"/112/static/_content/82-sub-2.png\">\n        <img class=\"halfScale 82-sub-3\" style=\"top:273px;left:66px;\" src=\"/112/static/_content/82-sub-3.png\">\n        <img class=\"halfScale 82-sub-4\" style=\"top:292px;left:115px;\" src=\"/112/static/_content/82-sub-4.png\">\n        <img class=\"halfScale 82-sub-5\" style=\"top:351px;left:124px;\" src=\"/112/static/_content/82-sub-5.png\">\n\n        <img class=\"halfScale 82-no-1\" style=\"top:419px;left:86px;\" src=\"/112/static/_content/82-no-1.png\">\n        <img class=\"halfScaleC 82-icon-1\" style=\"top:394px;left:104px;\" src=\"/112/static/_content/82-icon-1.png\">\n        <img class=\"halfScale 82-sub-6\" style=\"top:475px;left:135px;\" src=\"/112/static/_content/82-sub-6.png\">\n\n        <img class=\"halfScaleC 82-circ-1\" style=\"top:391px;left:155px;\" src=\"/112/static/_content/82-circ-1.png\">\n        <h1 id=\"82-no1\" class=\"abs 82-no hn-bd\" style=\"left:223px;top:448px; font-size: 2em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 26 }' ></h1>\n        <img class=\"halfScale 82-th\" style=\"top:455px;left:259px;\" src=\"/112/static/_content/82-th.png\">\n\n        <img class=\"halfScaleC 82-icon-2\" style=\"top:505px;left:82px;\" src=\"/112/static/_content/82-icon-2.png\">\n        <h1 id=\"82-no1\" class=\"abs 82-no hn-bd\" style=\"left:135px;top:624px; font-size: 1.8em; font-weight:300; margin:0; color:#fff; padding:0; margin:0;\"  data-number='{\"to\": 53, \"append\": \"%\" }' ></h1>\n        <img class=\"halfScale 82-sub-8\" style=\"top:660px;left:125px;\" src=\"/112/static/_content/82-sub-8.png\">\n\n        <img class=\"halfScale 82-no-2\" style=\"top:529px;left:226px;\" src=\"/112/static/_content/82-no-2.png\">\n        <img class=\"halfScale 82-sub-9\" style=\"top:532px;left:273px;\" src=\"/112/static/_content/82-sub-9.png\">\n        <img class=\"halfScaleC 82-icon-3\" style=\"top:568px;left:252px;\" src=\"/112/static/_content/82-icon-3.png\">\n        <img class=\"halfScale 82-wiggle-1\" style=\"top:643px;left:278px;\" src=\"/112/static/_content/82-wiggle-1.png\">\n\n        <img class=\"halfScale 82-sub-10\" style=\"top:196px;left:517px;\" src=\"/112/static/_content/82-sub-10.png\">\n        \n        <img class=\"halfScale 82-sub-11\" style=\"top:276px;left:649px;\" src=\"/112/static/_content/82-sub-11.png\">\n        <img class=\"halfScale 82-icon-4\" style=\"top:248px;left:522px;\" src=\"/112/static/_content/82-icon-4.png\">\n        <img class=\"halfScale 82-line-1\" style=\"top:350px;left:563px;\" src=\"/112/static/_content/82-line.png\">\n\n        <img class=\"halfScale 82-icon-5\" style=\"top:359px;left:522px;\" src=\"/112/static/_content/82-icon-5.png\">\n        <img class=\"halfScale 82-sub-12\" style=\"top:387px;left:649px;\" src=\"/112/static/_content/82-sub-12.png\">\n        <img class=\"halfScale 82-line-2\" style=\"top:459px;left:563px;\" src=\"/112/static/_content/82-line.png\">\n        <img class=\"halfScale 82-wiggle-2\" style=\"top:296px;left:620px;\" src=\"/112/static/_content/82-wiggle-2.png\">\n\n        <img class=\"halfScale 82-icon-6\" style=\"top:468px;left:522px;\" src=\"/112/static/_content/82-icon-6.png\">\n        <img class=\"halfScale 82-sub-13\" style=\"top:497px;left:649px;\" src=\"/112/static/_content/82-sub-13.png\">\n        <img class=\"halfScale 82-line-3\" style=\"top:568px;left:563px;\" src=\"/112/static/_content/82-line.png\">\n\n        <img class=\"halfScale 82-icon-7\" style=\"top:579px;left:522px;\" src=\"/112/static/_content/82-icon-7.png\">\n        <img class=\"halfScale 82-sub-14\" style=\"top:607px;left:649px;\" src=\"/112/static/_content/82-sub-14.png\">\n        <img class=\"halfScale 82-wiggle-3\" style=\"top:520px;left:620px;\" src=\"/112/static/_content/82-wiggle-2.png\">\n\n        <img class=\"halfScale 82-sub-15\" style=\"top:713px;left:66px;\" src=\"/112/static/_content/82-sub-15.png\">\n        <img class=\"halfScaleC 82-sub-16\" style=\"top:744px;left:13px;\" src=\"/112/static/_content/82-sub-16.png\">\n        <img class=\"halfScaleC 82-sub-17\" style=\"top:685px;left:229px;\" src=\"/112/static/_content/82-sub-17.png\">\n        <img class=\"halfScaleC 82-sub-18\" style=\"top:712px;left:476px;\" src=\"/112/static/_content/82-sub-18.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"82-sub-1\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-2\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-3\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-4\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-5\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-no-1\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-6\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-circ-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-no\")[0], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[0]);}}, \"-=0.5\")\n          .fromTo(cOf(\"82-th\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.5\")\n          .fromTo(cOf(\"82-no\")[1], 0.4, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"82-no\")[1]);}}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-8\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-no-2\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-3\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-9\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-wiggle-1\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-10\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-icon-4\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-11\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-line-1\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.6\")\n          .fromTo(cOf(\"82-icon-5\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-12\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-wiggle-2\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.6\")\n          .fromTo(cOf(\"82-line-2\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.6\")\n          .fromTo(cOf(\"82-icon-6\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-13\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-line-3\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.6\")\n          .fromTo(cOf(\"82-icon-7\"), 0.6, {opacity:0}, {opacity:1, ease: Power2.easeOut}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-14\"), 0.6, {x:30, opacity:0}, {x:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-wiggle-3\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.6\")\n          .fromTo(cOf(\"82-sub-15\"), 0.6, {y:30, opacity:0}, {y:0, opacity:1, ease: Power2.easeOut}, \"-=0.5\")\n          .fromTo(cOf(\"82-sub-16\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-17\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n          .fromTo(cOf(\"82-sub-18\"), 0.6, {scale:0}, {scale: 0.5, ease: Back.easeOut.config(1.7)}, \"-=0.4\")\n        }\n    \n        function onPageLeave() {\n          pg82Anim.stop();\n        }\n      ",
    "searchText": "Key facts and ﬁgures about the Olympic mascots  ES MASCOT MILESTONE  20 TOKYO 202 NAME  1ST OLYMPIC MASCOT Schuss appeared at the Olympic Winter Games Grenoble 1968    DESIGNS SUBMITTED BY THE PUBLIC  53%  OF CLASSES CHOSE MIRAITOWA FROM THE FINAL SHORTLIST  YOG MASCOTS 1STT YOG MASCOTS SCOTS Lyo andd Merly at Singapore pore 2010  82 OLYMPIC REVIEW  ETERNITY  1ST OFFICIAL MASCOT AT THE SUMMER GAMES Waldi at Munich 1972  26th OLYMPIC MASCOT  2 MASCOTS The ﬁrst mascot duo, Hidy and Howdy, appeared at Calgary 1988  PRIMARY SCHOOL CLASSES VOTED  75 55 205 755  2,042 2,0 042 42  FUTURE  5 MASCOTS The highest number at a Games at Beijing 2008  1ST MASCOTT WITH A HASHTAG AG #Pandi at Buenos oss Aires 2018  YODLI LAUSANNE 2020 A hybrid between a cow, goat and St Bernard dog  * INFORMATION SOURCED FROM IOC REPORTS AND OLYMPIC.ORG  Mirai towa"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length - 1) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-137252729-30',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eBnN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.36d1a80e854c0daf119d.js